{
    "headerData1": "MyHelp",
    "headerData2": "Váš AI asistent pro IT podporu",
    "headerMessage": "Použijte <span class='me8eon'>MyHelp</span> k řešení IT problémů, sledování krok za krokem průvodců nebo k přesměrování na správné kanály IT podpory.",
    "loginLable": "Přihlášení",
    "logOff": "Odhlásit se",
    "logIn": "Přihlásit se",
    "userName": "Název profilu",
    "switchLanguage": "Změnit jazyk",
    "switchRole": "Změnit roli",
    "new": "NOVÉ",
    "whatsnew": "Podívejte se, co je nového",
    "whatsnewtt": "Zjistěte, co je nového v MyHelp",
    "organiseTiles": "Organizovat dlaždice",
    "confirm": "Potvrdit",
    "cancel": "Zrušit",
    "close": "Zavřít",
    "reset": "Resetovat",
    "continue_Tour": "Pokračovat v prohlídce",
    "skip_Tour": "Přeskočit prohlídku",
    "save": "Uložit",
    "submit": "Odeslat",
    "delete": "Smazat",
    "trash_bin": "Smazat",
    "edit": "Upravit",
    "yes": "Ano",
    "no": "Ne",
    "feedbackWidget": "Feedback",
    "registerLable": "Pro registraci",
    "underDevelopmentMsg": "Tato stránka je ve vývoji",
    "apiFailDefaultMsg": "Něco se pokazilo. Zkuste to prosím později.",
    "more": "Více",
    "searchResult": "Výsledky hledání",
    "showAll": "Zobrazit vše",
    "showRelevant": "Zobrazit relevantní",
    "assistantTabTooltip": "Asistence odpovídá na vaše otázky vyhledáváním v interních zdrojích E.ON v reálném čase. Poskytuje jasné, snadno pochopitelné odpovědi se zdroji, abyste mohli důvěřovat informacím",
    "searchTabTooltip": "E.ON Search je tradiční vyhledávání, které vám pomůže rychle najít informace z různých zdrojů E.ON a vašich vlastních dat. Poskytuje nejrelevantnější výsledky a odkazy na zdroje",
    "landingPage": {
        "hello": "Ahoj",
        "title": "jak vám mohu pomoci?",
        "searchApps": "Aplikace",
        "suggestions": "Návrhy"
    },
    "footer": {
        "imprint": "Tiráž",
        "privacyPolicy": "Zásady ochrany osobních údajů",
        "termsofUse": "Podmínky použití",
        "contact": "Kontakt",
        "PKI": "PKI",
        "privacySettings": "Nastavení ochrany osobních údajů",
        "aboutMe8EON": "O MyHelp",
        "copyrights": "Autorská práva Obsah"
    },
    "tilePage": {
        "backToSearch": "Zpět na předchozí stránku",
        "myInboxCountSuffix": "Čekající"
    },
    "myApprovalDataTable": {
        "FilterLable": {
            "all": "Vše",
            "leaveApptoval": "LeaveApproval",
            "timeSheet": "TimeSheet",
            "claim": "Reklamace",
            "serviceRequest": "ServiceRequest"
        },
        "tableData": {
            "approve": "Schválit",
            "reject": "Odmítnout",
            "requestId": "ID žádosti",
            "description": "Popis",
            "requestedBy": "Žádáno kým",
            "requestedType": "Typ žádosti",
            "requestedDate": "Datum žádosti",
            "status": "Stav"
        }
    },
    "appData": {
        "time": "Sledování času",
        "meeting": "Rezervace zasedací místnosti",
        "approval": "Moje schválení",
        "pr": "Vytvořit požadavek na nákup",
        "pra": "Vytvořit pokročilý požadavek na nákup",
        "processing": "Moje schránka",
        "hr": "HR Portal",
        "hrLabel": "HR Portal",
        "concur": "Concur Rezervace cest a výdaje",
        "password": "Reset hesla SAP",
        "ariba": "Ariba - Classic a Classic+",
        "itresources": "IT zdroje",
        "myassets": "Moje aktiva",
        "order": "Objednávka",
        "incident": "Incidenty",
        "beeline": "Beeline",
        "prisma": "Prisma",
        "gertrud": "Gertrud",
        "notification": "Notification Portal",
        "zuko": "Zuko",
        "eon_brand": "EON Brand Space",
        "pki": "PKI Portal",
        "mail": "Mail DL",
        "journey": "Cesty/události",
        "mygenius": "MyGenius",
        "ideeon": "idEE.ON",
        "ideenet": "IdeeNet",
        "dpf": "Osobní složka - Digitální osobní složka - DPF",
        "corpsac": "Corporate SAC",
        "corpportal": "Corporate Portal",
        "redwood": "Redwood Finance Automation",
        "eamsap200": "EAM (200)",
        "eamsap100": "EAM (100)",
        "sodsap": "SoD SAP Portal",
        "videon": "VidE.ON",
        "alteryx": "Alteryx",
        "ebam": "Bankovnictví: Správa bankovních účtů (EBAM)",
        "egs": "E.ON Guarantee Solution",
        "epsnext": "EPSnext",
        "fisquantum": "FIS Quantum",
        "rms": "RMS - Řízení rizik",
        "slido": "Slido",
        "insightslibrary": "Knihovna poznatků",
        "getabstract": "getAbstract",
        "mypotential": "Dosahování mého potenciálu",
        "dsesoftware": "DSE Software",
        "whistleblowing": "E.ON Whistleblowing Solution",
        "maqsima": "MAQSIMA TMS",
        "digitalrulebook": "Paula Policy",
        "oneERP": "OneERP",
        "Perseus": "Vorfallsmeldung",
        "cateringportal": "Speiseplan",
        "westnetzregelwerke": "Regelwerke Westnetz",
        "werbemittel": "Werbemittel",
        "westenergie_brand": "Brand-Management-Portal",
        "compass": "Compass",
        "gradar": "Gradar",
        "beqom": "beqom",
        "kyc": "KYC",
        "talentry": "Talentry",
        "sam": "SAM",
        "enorm": "e-NORM",
        "redonline": "ROL",
        "tagetikcpm": "Tagetik CPM",
        "tagetikcpmerm": "Tagetik CPM a ERM",
        "smartguide": "Smart Guide",
        "tagetiksac": "Tagetik SAC",
        "myit": "my IT",
        "timehover": "Pomocí aplikace CATS můžete snadno sledovat a spravovat své pracovní hodiny a aktivity tím, že máte všechny relevantní informace a funkce na jednom místě.",
        "meetinghover": "S Gingco, naším nástrojem pro rezervaci místností, můžete snadno spravovat a plánovat své zasedací místnosti a zdroje, což zajišťuje efektivní využití a dostupnost, vše na jednom místě.",
        "approvalhover": "S myInbox můžete snadno a efektivně schvalovat faktury tím, že máte všechny relevantní informace a akce na jednom místě.",
        "prhover": "Zde najdete všechny relevantní funkce pro požadování zboží a služeb. To je také známé jako BANF (něm. pro požadavek na nákup).",
        "prahover": "Zde najdete všechny relevantní funkce pro požadování zboží a služeb. To je také známé jako BANF (něm. pro požadavek na nákup).",
        "processinghover": "S myInbox můžete snadno a efektivně schvalovat faktury tím, že máte všechny relevantní informace a akce na jednom místě.",
        "hrhover": "S myHR můžete pohodlně přistupovat a spravovat své HR informace a úkoly na jednom místě.",
        "concurhover": "S Concur můžete snadno spravovat a podávat své cestovní a výdajové zprávy tím, že máte všechny relevantní informace a akce na jednom místě.",
        "passwordhover": "Pomocí této dlaždice můžete snadno resetovat přístupová hesla pro vaše SAP systémy.",
        "aribahover": "S SAP Ariba můžete snadno spravovat své procesy nákupu tím, že máte všechny relevantní informace a nástroje na jednom místě.",
        "itresourceshover": "IT zdroje",
        "myassetshover": "Moje aktiva",
        "orderhover": "Objednávka",
        "incidenthover": "Incidenty",
        "beelinehover": "S Beeline můžete efektivně spravovat svou dočasnou pracovní sílu a zjednodušit své procesy náboru tím, že máte všechny potřebné nástroje a informace na jednom místě.",
        "prismahover": "PRISMA znamená Platforma pro reportování incidentů a řízení udržitelnosti a auditování. Platforma podporuje oddělení HSE společnosti E.ON v jeho misi učinit z E.ON zdravé, bezpečné a ekologicky uvědomělé místo. PRISMA je dostupná jak prostřednictvím webu, tak jako aplikace.",
        "gertrudhover": "Gertrud",
        "notificationhover": "Notification Portal",
        "zukohover": "Zuko",
        "eon_brandhover": "EON Brand Space",
        "pkihover": "PKI Portal",
        "mailhover": "Mail DL",
        "journeyhover": "Cesty/události",
        "mygeniushover": "MyGenius",
        "ideeonhover": "Idee.on je platforma, která umožňuje zaměstnancům předkládat a hodnotit nápady a návrhy pro řízení nápadů. Je navržena tak, aby usnadnila proces neustálého zlepšování ve všech oblastech společnosti.",
        "ideenethover": "IdeeNet je software pro řízení nápadů v pravém slova smyslu. Různé nápady, jako například &#10;&bull; Centralizované BVW, decentralizované BVW a smíšené formy &#10;&bull; Kvalitní kruhy a CIP &#10;&bull; Zprávy o chybách a stížnostech &#10;&bull; Zaměstnanecké vynálezy &#10;mohou být efektivně řešeny pomocí tohoto softwaru, v jednotné databázi nápadů, ale s využitím různých strategií.",
        "dpfhover": "Vaše osobní složka obsahuje mnohem více dokumentů než ty, které jsou trvale zobrazeny v MyHR! &#10;Podat HR požadavek a požádat o přístup k celé osobní složce! Po odborném přezkoumání bude k dispozici prostřednictvím přímého odkazu.",
        "corpsachover": "SAC je výkonný vizualizační nástroj s pokročilými plánovacími schopnostmi.",
        "corpportalhover": "Corporate Portal je centrální interní aplikační platforma s integrací aplikací na základě rolí a vývojem pro přístup Single-Sign-On k SAP backendům.",
        "redwoodhover": "Redwood FA se používá k plánování konsolidovaných finančních výkazů a automatizaci jednotlivých aktivit.",
        "eamsap200hover": "Enterprise Asset Management &#10;Prostředí pro vlastní vývoj na základě Business technology platformy (BTP) od SAP (dříve SAP Cloud Platform) - EAM účet pro grid cockpits, včetně cloudových instancí: produkce, QA (Quality Assurance), vývoj a staging.",
        "eamsap100hover": "Enterprise Asset Management &#10;Prostředí pro vlastní vývoj na základě Business technology platformy (BTP) od SAP (dříve SAP Cloud Platform) - EAM účet pro grid cockpits, včetně cloudových instancí: produkce, QA (Quality Assurance), vývoj a staging.",
        "sodsaphover": "SOD-Portal je navržen tak, aby zjednodušil a digitalizoval řízení Segregation of Duties (SOD). Digitalizací identifikace, monitorování a řešení konfliktů SOD zajišťuje soulad s regulačními standardy a zvyšuje bezpečnost organizace. Tento nástroj je nezbytný pro udržení robustního systému interního řízení a ochranu vašich obchodních operací.",
        "videonhover": "Aplikace pro rezervaci služeb z video/TV studia na Brüsseler Platz pro produkci videa/TV nebo streamingovou událost.",
        "alteryxhover": "Platforma pro analýzu dat používaná k vytváření analytických aplikací a pracovních toků. Umožňuje uživatelům spravovat a sdílet analytické aplikace, spouštět pracovní toky a přistupovat k výstupům a reportovat o nich v serverovém prostředí.",
        "ebamhover": "Elektronická správa bankovních účtů",
        "egshover": "E.ON SE přebírá ručení a záruky za BU skupiny vůči externím věřitelům.",
        "epsnexthover": "Centrální elektronický bankovní nástroj pro všechny MU/Bus.",
        "fisquantumhover": "Řešení FIS Quantum Treasury Management je navrženo tak, aby zlepšilo efektivitu a účinnost operací vaší organizace v oblasti treasury. Tato cloudová platforma poskytuje viditelnost v reálném čase do hotovosti a likvidity, což umožňuje lepší rozhodování o kapitálu a řízení rizik. S pokročilými funkcemi pro řízení dluhu, investic a souladu pomáhá zjednodušit pracovní toky a zlepšit finanční výkon.",
        "rmshover": "Skupinový systém řízení rizik E.ON (zpracování žádostí o úvěr a systém řízení úvěrových rizik).",
        "slidohover": "Slido je interaktivní platforma navržená k posílení zapojení publika a získání poznatků během živých nebo virtuálních událostí, schůzek a prezentací. Umožňuje uživatelům provádět živé ankety, Q&A sezení a kvízy v reálném čase, čímž vytváří dynamický a participativní zážitek pro publikum.",
        "insightslibraryhover": "Insights Library je centrální znalostní úložiště E.ON pro poznatky o zákaznících a trhu v rámci obchodní oblasti zákaznických řešení.",
        "getabstracthover": "getAbstract je celoskupinová online knihovna E.ON, poskytovaná getAbstract, s přehledy knih, články a dalšími formáty učení, které pokrývají všechny obchodně relevantní dovednosti (měkké dovednosti a funkční dovednosti).",
        "mypotentialhover": "Systém pro zaměstnance a manažery ve Velké Británii k zaznamenávání jejich výkonu, cílů a hodnocení.",
        "dsesoftwarehover": "Výcvik a hodnocení obrazovky pro zdraví a bezpečnost.",
        "whistleblowinghover": "Nástroj Whistleblowing umožňuje komukoli, kdo poskytuje informace, podat zprávu anonymně. To lze provést prostřednictvím webového příjmu, e-mailu nebo telefonu. Během hovoru bude váš hlas zkreslen.",
        "maqsimahover": "Řízení hodnocení rizik, provozních pokynů, nebezpečných látek &#10;Maqsima vám pomáhá rychle a snadno sledovat všechny relevantní hodnocení rizik a provozní pokyny a udržovat je aktuální chytrým způsobem.",
        "digitalrulebookhover": "Paula Policy je asistent pro firemní směrnice E.ON využívající umělou inteligenci, který zaměstnancům poskytuje rychlý a snadný přístup k People Guidelines, Function Policies a Code of Conduct. Poskytuje konzistentní a spolehlivé odpovědi a zpřístupňuje složité směrnice srozumitelnou formou.",
        "oneERPhover": "Portál one.ERP je centrální platforma v rámci skupiny Westenergie, která konsoliduje různé funkce a informace související s ERP. Slouží jako informační a kontrolní centrum pro uživatele ERP a IT manažery a je součástí celkové digitalizační strategie skupiny.",
        "Perseushover": "Security Portal je centrální přístupový bod pro hlášení bezpečnostních incidentů v rámci organizací Westenergie a Westnetz. Často se používá ve spojení s interním systémem hlášení Perseus, který je speciálně navržen pro řešení incidentů, jako je ztráta zařízení, krádež nebo porušení ochrany dat.",
        "cateringportalhover": "Portál eon.cateringportal.io je digitální platforma pro aplikaci E.ON Canteen App. Poskytuje jídelní plány, podrobnosti o lokalitách a další cateringové služby pro zaměstnance E.ON.",
        "westnetzregelwerkehover": "Tento portál slouží jako centrální zdroj technických předpisů a dokumentace související s provozem a řízením elektrických a plynových sítí. Zajišťuje, že všechny relevantní pokyny, standardy a technické specifikace potřebné pro bezpečný a efektivní provoz sítí jsou dostupné.",
        "werbemittelhover": "Obchod s propagačními předměty Westenergie je online platforma, prostřednictvím které mohou zaměstnanci a autorizovaní partneři skupiny Westenergie objednávat propagační předměty a komunikační materiály.",
        "westenergie_brandhover": "Obrazová databáze Westenergie stejně jako prvky značky a designové pokyny skupiny Westenergie. Přístup ke všem komponentům naší značky pro vytváření momentů Westenergie. Od systému řízení značky se všemi důležitými pokyny pro používání prvků značky, jako jsou loga, symboly a naše chatovací boxy, až po mediální knihovnu s množstvím obrázků pro všechny designové varianty.",
        "compasshover": "Compass je celoskupinová interní komunikační platforma pro zprávy a obsah E.ON, networking a výměnu zaměstnanců.",
        "gradarhover": "Tento nástroj se používá k zahájení procesu hodnocení vedoucích zaměstnanců.",
        "beqomhover": "Beqom se používá celoskupinově pro správu a komunikaci dlouhodobých motivačních plánů E.ON. Používá se HR, účetnictvím, daněmi a vedoucími pracovníky. Vedle záležitostí dlouhodobých motivačních plánů může být beqom také použit pro vytváření dopisů o platbě a bonusu a celkových odměnových prohlášení.",
        "kychover": "S nástrojem Know-Your-Counterpart (KYC) můžete prověřovat protistrany podle standardních politik (např.: PG-03).",
        "talentryhover": "Využijte tuto příležitost k sdílení našich aktuálních pracovních nabídek s talentovanými lidmi ve vaší síti - lidmi, kteří chtějí pomoci formovat budoucnost svou energií.",
        "samhover": "Pomocí tohoto nástroje můžete provádět povinné školení o bezpečnosti.",
        "enormhover": "e-NORM je výkonný software pro správu, poskytování a aktualizaci dat souvisejících s kontrolou kvality nebo standardními dokumenty, stejně jako pro propojení souvisejících souborů.",
        "redonlinehover": "Compliance Monitor Red-on-line (ROL) zjednodušuje řízení souladu s předpisy tím, že poskytuje aktualizace v reálném čase o předpisech v oblasti životního prostředí, zdraví a bezpečnosti (EHS). Nabízí monitorování a dashboardy, které vám pomohou proaktivně řešit problémy s dodržováním předpisů. Tento nástroj je nezbytný pro udržení bezpečného a souladu s předpisy pracoviště, snižování rizik a zlepšování provozní efektivity.",
        "tagetikcpmhover": "Tagetik Corporate Performance Management (CPM) aplikace pro rozpočtování a plánování, konsolidaci, riziko a řízení reportingu (zavedeno Finance Excellence) E.ON SE (Group Reporting). Hlavní procesy jsou čtvrtletní uzávěrky, které mají velmi vysoký externí dopad kvůli tvrdému termínu pro komunikaci na kapitálovém trhu.",
        "tagetikcpmermhover": "Tagetik Corporate Performance Management (CPM) a Enterprise Risk Management (ERM) aplikace pro rozpočtování a plánování, konsolidaci, riziko a řízení reportingu (zavedeno Finance Excellence) E.ON SE (Group Reporting). Hlavní procesy jsou čtvrtletní uzávěrky, které mají velmi vysoký externí dopad kvůli tvrdému termínu pro komunikaci na kapitálovém trhu.",
        "smartguidehover": "Smart Guide Hub je wiki, která má být redakčně udržována několika kolegy, aby poskytovala politiky pro cca 4000 uživatelů v oblastech IFRS, Controlling, HGB a ESG.",
        "tagetiksachover": "Tagetik Dashboard. Tagetik je aplikace pro rozpočtování a plánování, konsolidaci, riziko a řízení reportingu (zavedeno Finance Excellence) E.ON SE (Group Reporting). Hlavní procesy jsou čtvrtletní uzávěrky, které mají velmi vysoký externí dopad kvůli tvrdému termínu pro komunikaci na kapitálovém trhu.",
        "myithover": "Vaše místo pro vše, co souvisí s IT: možnosti podpory, užitečné odkazy, komunity a nejnovější zprávy, které potřebujete vědět.",
        "servicehub": "Service Hub",
        "servicehubhover": "S EON Service Hub můžete snadno požadovat nový software a hardware včetně laptopů a monitorů a získat IT podporu tím, že nahlásíte problémy nebo budete chatovat s my IT support, vše na jednom místě.",
        "SailPoint": "Přehled řízení identit",
        "P29": "SAP EIC",
        "P83": "SAP EIC",
        "BIC": "BIC Cloud / BIC Process Design",
        "Celonis": "Celonis Process Mining",
        "Carsync": "Carsync Správa vozového parku",
        "ISUSpace": "ISU/Space",
        "GNIS": "GNIS (EDI)",
        "ecount_EDI": "ecount EDI",
        "SAP_Datasphere_EDI": "SAP Datasphere EDI",
        "SailPointhover": "S SailPoint lze centrálně spravovat přístupová práva a identity.",
        "P29hover": "S SAP EIC lze efektivně zpracovávat a dokumentovat tikety a dotazy zákazníků. Aplikace podporuje integraci s ECG a poskytuje centrální rozhraní pro ticketing.",
        "P83hover": "S SAP EIC lze efektivně zpracovávat a dokumentovat tikety a dotazy zákazníků. Aplikace podporuje integraci s ECG a poskytuje centrální rozhraní pro ticketing.",
        "BIChover": "S BIC Cloud lze modelovat, analyzovat a optimalizovat obchodní procesy.",
        "Celonishover": "Process Mining: Analýza skutečných procesů na základě záznamů událostí z ERP, CRM a dalších systémů. Execution Management: Automatizace pracovních toků a doporučení akcí. Process Optimization: Identifikace neefektivit, např. v procesech Purchase-to-Pay nebo Order-to-Cash. Integration: Připojení k systémům jako SAP, Salesforce, Oracle, atd.",
        "Carsynchover": "S Carsync lze efektivně spravovat firemní auta a vozové parky, dokumentovat cesty a optimalizovat náklady.",
        "ISUSpacehover": "S ISU/Space lze snadno rezervovat a spravovat pracovní místa a zasedací místnosti.",
        "GNIShover": "S GNIS lze efektivně spravovat a vyměňovat master data a síťová data pro tržní komunikaci (EDI).",
        "ecount_EDIhover": "S eccount lze spravovat, vyměňovat a analyzovat EDI-relevantní master a síťová data.",
        "SAP_Datasphere_EDIhover": "S SAP Datasphere lze integrovat, modelovat a zpřístupňovat data z různých zdrojů pro analýzy a obchodní rozhodnutí. Platforma podporuje samoobsluhu, správu dat a přístup k datům v reálném čase.",
        "CFLP": "CFLP",
        "corporateWorkspace": "Corporate Workspace",
        "SAPWebLaunchpad": "SAP Web Launchpad",
        "CFLPhover": "Centrální vstupní bod pro SAP systémy a cloudové služby.",
        "corporateWorkspacehover": "SAP Build Work Zone, Advanced Edition umožňuje vytvářet digitální pracovní prostředí pro zvýšení produktivity a zapojení uživatelů. Centralizuje přístup k relevantním obchodním aplikacím, procesům, informacím a komunikaci v jednom vstupním bodě, ke kterému mohou uživatelé přistupovat z jakéhokoli zařízení.",
        "SAPWebLaunchpadhover": "SAP Web Launchpad poskytuje přístup k SAP systémům přes web pomocí Fiori a WebGUI. Přizpůsobitelná úvodní stránka včetně oblíbených položek umožňuje rychlý přístup k SAP systémům a klientům.",
        "PKI_Semnatura_Digitala_6781": "PKI - Digitální podpis",
        "Users_Access_EER_9163": "RAPPS EER",
        "Evaluare_Personal_EER_2935": "Hodnocení zaměstnanců EER",
        "Sesizari_Administrare_Cladiri_EER_8543": "Hlášení správy budov EER",
        "MRBS_EER_8445": "MRBS EER",
        "Delegatii_EER_1137": "Služební cesty EER",
        "Users_Access_EER_5369": "Uživatelský přístup EER",
        "Planificare_Concedii_EER_8588": "Plánování dovolené EER",
        "Pontaje_si_Telemunca_EER_7087": "Evidence pracovní doby a práce na dálku EER",
        "BOT_6231": "BOT",
        "Bonusare_personal_6879": "Bonusy zaměstnanců",
        "GRC_Request_5510": "Požadavek GRC",
        "iPEN_Portal_3047": "Portál iPEN",
        "YourVoiceEON_0693": "YourVoice@E.ON",
        "ITPortal_5530": "IT portál (Süwag)",
        "Transf4m_Ticket_Tool_6635": "Transf4m Ticket Tool (Süwag)",
        "Speedikon_C_1281": "Speedikon C (Süwag)",
        "Speiseplan_8904": "Speiseplan (Süwag)",
        "Ariba_8690": "Ariba",
        "DiSch_20_0545": "DiSch 2.0",
        "ISMSMeldezentrale_9318": "ISMS-Meldezentrale (Süwag)",
        "SAP_Launchpad_8736": "SAP Launchpad (Süwag)",
        "HR_Portal_3311": "HR Portal (Süwag)",
        "Confluence_9100": "Confluence (Süwag)",
        "my_IT_order_6623": "my IT order",
        "BAT_Business_Activity_Tracker_7022": "BAT PL",
        "CTP_2407": "CTP PL",
        "BPM_OSD_PL_5209": "BPM OSD PL",
        "jflow_PL_6875": "jflow PL",
        "Qmatic_PL_CS_3195": "Qmatic PL CS",
        "Qmatic_PL_EN_3118": "Qmatic PL EN",
        "CCM_Inspire_7264": "CCM Inspire",
        "Atoss_artelisGruppe_und_VSEAgentur_3137": "Atoss artelis-Gruppe und VSE-Agentur",
        "Atoss_VSEGruppe_4374": "Atoss VSE-Gruppe",
        "AWS_Access_Portal_1318": "AWS Access Portal",
        "eDIVA_5372": "eDIVA",
        "G2G_VSEGruppe_6518": "G2G VSE-Gruppe",
        "AWS_Access_Portal_6740": "AWS Access Portal",
        "Qualys_Security_4331": "Qualys Security",
        "ODIN_FinOps_6411": "ODIN FinOps",
        "Cloudflare_4507": "Cloudflare",
        "ADP_TRAVEL_REISEMANAGEMENT_3368": "ADP TRAVEL REISEMANAGEMENT",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292": "Nahlásit IT bezpečnostní incident VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987": "Nahlásit HSE incident VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571": "Jídelníček VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367": "IT hlásicí formulář VSE-Gruppe",
        "LeanIX_5372": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902": "VSE Wiki CONFLUENCE",
        "Young_Talents_AzubiPortal_3338": "Young Talents Azubi-Portal",
        "Workday_Peakon_eNPS_1749": "Workday Peakon eNPS",
        "Umantis_0386": "Umantis",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447": "Potvrzení a další HR aplikace (RO CS)",
        "Deconturi_card_companie_RO_CS_5333": "Vyúčtování firemní kartou (RO CS)",
        "Documente_delegatii_RO_CS_5332": "Dokumenty služebních cest (RO CS)",
        "SAP_ISU_CS_RO_8555": "SAP IS-U CS RO",
        "PKI_Semnatura_Digitala_6781hover": "Obnovit token",
        "Users_Access_EER_9163hover": "RAPPS EER",
        "Evaluare_Personal_EER_2935hover": "Portál hodnocení zaměstnanců EER",
        "Sesizari_Administrare_Cladiri_EER_8543hover": "Portál hlášení správy budov EER",
        "MRBS_EER_8445hover": "Rezervace zasedací místnosti EER",
        "Delegatii_EER_1137hover": "Portál služebních cest EER",
        "Users_Access_EER_5369hover": "Formulář uživatelského přístupu EER",
        "Planificare_Concedii_EER_8588hover": "Plánování dovolené EER",
        "Pontaje_si_Telemunca_EER_7087hover": "Evidence pracovní doby a práce na dálku EER",
        "BOT_6231hover": "Proplacení rekreačních a léčebných poukazů",
        "Bonusare_personal_6879hover": "Bonusy zaměstnanců",
        "GRC_Request_5510hover": "GRC znamená Governance & Risk Compliance Access Control a je to nástroj SAP Workflow pro automatizované žádosti, schvalování a přidělování uživatelských oprávnění v systémech SAP.",
        "iPEN_Portal_3047hover": "Information Platform of Energy Networks, zkráceně iPEN, zajišťuje, že data regionálních jednotek mohou být sdružována a centrálně poskytována. Stávající i nově vyvíjená inteligentní řešení jsou k platformě připojována. Díky tomu je lze nákladově efektivně, rychle a flexibilně nasazovat napříč celou síťovou komunitou. iPEN je tak klíčovým nástrojem pro škálování inteligentních řešení.",
        "YourVoiceEON_0693hover": "Platforma PEAKON vám jednou týdně zasílá přibližně 4-5 otázek týkajících se vašeho pocitu pohody a vaší aktuální pracovní situace. Otázky můžete ohodnotit (0-10), okomentovat nebo přeskočit. Odpovědi na těchto několik otázek zaberou jen asi 1-2 minuty.",
        "ITPortal_5530hover": "IT servisní portál společnosti Süwag",
        "Transf4m_Ticket_Tool_6635hover": "Nástroj Transf4m Ticket Tool",
        "Speedikon_C_1281hover": "Speedikon C",
        "Speiseplan_8904hover": "Jídelníček",
        "Ariba_8690hover": "Nákupní portál",
        "DiSch_20_0545hover": "Toto je moje digitální pracoviště",
        "ISMSMeldezentrale_9318hover": "ISMS-Meldezentrale",
        "SAP_Launchpad_8736hover": "SAP Launchpad",
        "HR_Portal_3311hover": "HR Portal",
        "Confluence_9100hover": "Confluence společnosti Süwag",
        "my_IT_order_6623hover": "my IT order",
        "BAT_Business_Activity_Tracker_7022hover": "Vykazování času",
        "CTP_2407hover": "CTP (Čas jsou peníze)",
        "BPM_OSD_PL_5209hover": "BPM PP + CRM DSO",
        "jflow_PL_6875hover": "Podpora zpracování obchodních procesů pomocí Jira",
        "Qmatic_PL_CS_3195hover": "Aplikace pro správu toku zákazníků (front) v POS",
        "Qmatic_PL_EN_3118hover": "Aplikace pro správu toku zákazníků (front) v POS",
        "CCM_Inspire_7264hover": "Centralizovaná platforma E.ON pro řízení komunikace se zákazníky (CCM) poháněná nástrojem Quadient Inspire pro tvorbu a doručování zákaznické komunikace.",
        "Atoss_artelisGruppe_und_VSEAgentur_3137hover": "Toto je náš systém pro sledování času",
        "Atoss_VSEGruppe_4374hover": "Toto je náš systém pro sledování času",
        "AWS_Access_Portal_1318hover": "Přístup k AWS účtům",
        "eDIVA_5372hover": "Správa uživatelů ANF",
        "G2G_VSEGruppe_6518hover": "GIS systém VSE-Gruppe",
        "AWS_Access_Portal_6740hover": "Přístup do cloudu AWS VSE-Gruppe",
        "Qualys_Security_4331hover": "Monitorování podnikových rizik",
        "ODIN_FinOps_6411hover": "ODIN FinOps VSE-Gruppe",
        "Cloudflare_4507hover": "Cloudflare VSE-Gruppe",
        "ADP_TRAVEL_REISEMANAGEMENT_3368hover": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292hover": "Nahlásit IT bezpečnostní incident VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987hover": "Nahlásit HSE incident VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571hover": "Jídelníček VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367hover": "IT hlásicí formulář VSE-Gruppe",
        "LeanIX_5372hover": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902hover": "Návody",
        "Young_Talents_AzubiPortal_3338hover": "Young Talents Azubi-Portal VSE-Gruppe",
        "Workday_Peakon_eNPS_1749hover": "Workday Peakon eNPS",
        "Umantis_0386hover": "Umantis VSE-Gruppe",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447hover": "Účelem této aplikace je umožnit každému uživateli stáhnout různé typy potvrzení maximálně na tři kliknutí. Aplikace také nabízí funkce pro správce HR a koordinátory, kteří mohou stahovat potvrzení pro své kolegy. Zaměstnanci si navíc mohou vypočítat délku zaměstnání, podporu při odchodu do důchodu a požádat oddělení HR o další dokumenty.",
        "Deconturi_card_companie_RO_CS_5333hover": "Držitelé firemních karet mohou prostřednictvím této aplikace snadno podávat vyúčtování výdajů, aniž by museli posílat účtenky e-mailem či poštou nebo žádat o schválení e-mailem. Celý proces probíhá v této platformě.",
        "Documente_delegatii_RO_CS_5332hover": "Aplikace pro správu služebních cest umožňuje uživatelům přidávat dokumenty ke svým cestám i cestám podřízených. Správci HR mohou dokumenty hromadně zobrazovat, filtrovat a uzavírat a také žádat o další dokumenty prostřednictvím automaticky odesílaných e-mailů.",
        "SAP_ISU_CS_RO_8555hover": "Služba zahrnuje činnosti související se systémy SAP IS-U x7G používanými společností E.ON RO CS.",
        "subTitle": {
            "PKI_Semnatura_Digitala_6781SubTitle": "Obnovit / Resetovat token",
            "Users_Access_EER_9163subTitle": "RAPPS EER",
            "Evaluare_Personal_EER_2935subTitle": "Portál hodnocení zaměstnanců EER",
            "Sesizari_Administrare_Cladiri_EER_8543subTitle": "Portál hlášení správy budov EER",
            "MRBS_EER_8445subTitle": "Rezervace zasedací místnosti EER",
            "Delegatii_EER_1137subTitle": "Portál služebních cest EER",
            "Users_Access_EER_5369subTitle": "Formulář uživatelského přístupu EER",
            "Planificare_Concedii_EER_8588subTitle": "Plánování dovolené EER",
            "Pontaje_si_Telemunca_EER_7087subTitle": "Evidence pracovní doby a práce na dálku EER",
            "BOT_6231subTitle": "Proplacení rekreačních a léčebných poukazů",
            "Bonusare_personal_6879subTitle": "Bonusy zaměstnanců",
            "GRC_Request_5510SubTitle": "Požadavek GRC",
            "iPEN_Portal_3047SubTitle": "Informační platforma energetických sítí",
            "YourVoiceEON_0693SubTitle": "YourVoice@E.ON",
            "ITPortal_5530SubTitle": "Süwag",
            "Transf4m_Ticket_Tool_6635SubTitle": "JIRA",
            "Speedikon_C_1281SubTitle": "Rezervace pracovních míst",
            "Speiseplan_8904SubTitle": "Höchst",
            "Ariba_8690SubTitle": "Nákupní portál",
            "DiSch_20_0545SubTitle": "Digitální pracoviště",
            "ISMSMeldezentrale_9318SubTitle": "Süwag",
            "SAP_Launchpad_8736SubTitle": "WEB",
            "HR_Portal_3311SubTitle": "Selfservices",
            "Confluence_9100SubTitle": "Süwag",
            "my_IT_order_6623SubTitle": "E.ON",
            "BAT_Business_Activity_Tracker_7022SubTitle": "Sledování obchodních aktivit",
            "CTP_2407SubTitle": "Czas to pieniądz",
            "BPM_OSD_PL_5209SubTitle": "BPM PP + CRM DSO",
            "jflow_PL_6875SubTitle": "Zpracování obchodních procesů",
            "Qmatic_PL_CS_3195SubTitle": "Qmatic E.ON Polska",
            "Qmatic_PL_EN_3118SubTitle": "Qmatic Stoen Operator",
            "CCM_Inspire_7264SubTitle": "CCM - Platforma",
            "Atoss_artelisGruppe_und_VSEAgentur_3137SubTitle": "artelis-Gruppe und VSE-Agentur",
            "Atoss_VSEGruppe_4374SubTitle": "Atoss VSE-Gruppe",
            "AWS_Access_Portal_1318SubTitle": "IT - CloudCore",
            "eDIVA_5372SubTitle": "eDIVA Správa uživatelů ANF -> eDIVA",
            "G2G_VSEGruppe_6518SubTitle": "G2G VSE-Gruppe",
            "AWS_Access_Portal_6740SubTitle": "AWS Access Portal VSE-Gruppe",
            "Qualys_Security_4331SubTitle": "Qualys Security VSE-Gruppe",
            "ODIN_FinOps_6411SubTitle": "ODIN FinOps VSE-Gruppe",
            "Cloudflare_4507SubTitle": "Cloudflare VSE-Gruppe",
            "ADP_TRAVEL_REISEMANAGEMENT_3368SubTitle": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
            "ITSicherheitsvorfall_melden_VSEGruppe_9292SubTitle": "Nahlásit IT bezpečnostní incident VSE-Gruppe",
            "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987SubTitle": "Nahlásit HSE incident VSE-Gruppe",
            "Speiseplan_VSEGruppe_3571SubTitle": "Jídelníček VSE-Gruppe",
            "ITMeldebogen_VSEGruppe_1367SubTitle": "IT hlásicí formulář VSE-Gruppe",
            "LeanIX_5372SubTitle": "LeanIX",
            "VSE_Wiki_CONFLUENCE_1902SubTitle": "VSE Wiki CONFLUENCE",
            "Young_Talents_AzubiPortal_3338SubTitle": "Young Talents Azubi-Portal VSE-Gruppe",
            "Workday_Peakon_eNPS_1749SubTitle": "Workday Peakon eNPS",
            "Umantis_0386SubTitle": "Umantis VSE-Gruppe",
            "Adeverinte_alte_aplicatii_HR_RO_CS_2447SubTitle": "Potvrzení a další HR aplikace (RO CS)",
            "Deconturi_card_companie_RO_CS_5333SubTitle": "Vyúčtování firemní kartou (RO CS)",
            "Documente_delegatii_RO_CS_5332SubTitle": "Dokumenty služebních cest (RO CS)",
            "SAP_ISU_CS_RO_8555SubTitle": "SAP IS-U CS RO",
            "CFLPSubTitle": "Centrální Fiori Launchpad",
            "corporateWorkspaceSubTitle": "SAP Build Work Zone, Advanced Edition",
            "SAPWebLaunchpadSubTitle": "Odkazy na SAP systémy",
            "timeSubTitle": "CATS",
            "meetingSubTitle": "GINGCO",
            "approvalSubTitle": "SNOW/SAP",
            "prSubTitle": "BANF",
            "praSubTitle": "BANF",
            "processingSubTitle": "SAP",
            "hrSubTitle": "MyHR",
            "concurSubTitle": "SAP Concur",
            "passwordSubTitle": "SAP Systems",
            "aribaSubTitle": "PO Přehled",
            "itresourcesSubTitle": "SNOW",
            "incidentSubTitle": "SNOW",
            "orderSubTitle": "Objednávka IT služeb",
            "myassetsSubTitle": "SNOW",
            "beelineSubTitle": "Externí nábor",
            "prismaSubTitle": "HSE",
            "gertrudSubTitle": "Příprava zasedání představenstva",
            "notificationSubTitle": "Facility Services",
            "zukoSubTitle": "Organizace stěhování kanceláře",
            "eon_brandSubTitle": "it's on us",
            "pkiSubTitle": "Správa certifikátů",
            "mailSubTitle": "Údržba",
            "journeySubTitle": "FuV §37b EstG",
            "mygeniusSubTitle": "Digitální vzdělávací platforma",
            "ideeonSubTitle": "Řízení nápadů",
            "ideenetSubTitle": "Řízení nápadů",
            "dpfSubTitle": "Digitální osobní složka",
            "corpsacSubTitle": "SAC",
            "corpportalSubTitle": "Corporate Portal",
            "redwoodSubTitle": "Redwood FA",
            "eamsap200SubTitle": "SAP Cloud Cockpits (200)",
            "eamsap100SubTitle": "SAP Cloud Cockpits (100)",
            "sodsapSubTitle": "SoD-Portal",
            "videonSubTitle": "VidEON",
            "alteryxSubTitle": "Alteryx",
            "ebamSubTitle": "EBAM",
            "egsSubTitle": "EGS",
            "epsnextSubTitle": "EPSnext",
            "fisquantumSubTitle": "FIS Quantum",
            "rmsSubTitle": "RMS",
            "slidoSubTitle": "Slido",
            "insightslibrarySubTitle": "Znalostní úložiště",
            "getabstractSubTitle": "Online knihovna",
            "mypotentialSubTitle": "AMP",
            "dsesoftwareSubTitle": "DSE",
            "whistleblowingSubTitle": "E.ON Whistleblowing Solution",
            "maqsimaSubTitle": "Řízení hodnocení rizik",
            "digitalrulebookSubTitle": "Skupinové pokyny",
            "oneERPSubTitle": "EAM/ESM",
            "PerseusSubTitle": "Perseus",
            "cateringportalSubTitle": "Cateringportal",
            "westnetzregelwerkeSubTitle": "nScale",
            "werbemittelSubTitle": "Werbemittelshop",
            "westenergie_brandSubTitle": "Westenergie Frontify",
            "compassSubTitle": "Celoskupinová interní komunikační platforma",
            "gradarSubTitle": "Hodnocení pracovních míst a odměňování",
            "beqomSubTitle": "beqom",
            "kycSubTitle": "Kontrola souladu protistran",
            "talentrySubTitle": "Program doporučení pracovních míst",
            "samSubTitle": "Školení o bezpečnosti @E.On",
            "enormSubTitle": "Compliance Monitor",
            "redonlineSubTitle": "red-on-line",
            "tagetikcpmSubTitle": "CPM",
            "tagetikcpmermSubTitle": "CPM a ERM",
            "smartguideSubTitle": "Smart Guide Hub (Účetní wiki)",
            "tagetiksacSubTitle": "Tagetik SAP Analytics Cloud",
            "servicehubSubTitle": "Service Hub",
            "myitSubTitle": "IT podpora a novinky",
            "SailPointSubTitle": "Přehled řízení identit a přístupu",
            "P29SubTitle": "SAP EIC",
            "P83SubTitle": "SAP P83",
            "BICSubTitle": "BIC Cloud",
            "CelonisSubTitle": "Process Mining",
            "CarsyncSubTitle": "Správa vozového parku",
            "ISUSpaceSubTitle": "Správa pracovních míst a místností",
            "GNISSubTitle": "Správa master dat EDI",
            "ecount_EDISubTitle": "Správa dat EDI",
            "SAP_Datasphere_EDISubTitle": "Integrace dat & Business Data Fabric",
            "ukhrSubTitle": "UK HR App"
        },
        "ukhr": "UK HR App",
        "ukhrhover": "Vaše jediné místo pro vše, co se týká UK HR. Od výplatních pásek po rezervaci dovolené a vše mezi tím. Začněte s našimi průvodci pro zaměstnance a manažery nebo vyhledejte vše o HR níže."
    },
    "searchPage": {
        "searchPlaceholder": "Hledat...",
        "searchApps": "Hledejte zde...",
        "relatedApps": "Aplikace",
        "viewMoreApps": "Více",
        "removeAppTooltip": "Odebrat z Dashboardu",
        "addAppTooltip": "Přidat na Dashboard",
        "addedAppTooltip": "Přidáno na Dashboard"
    },
    "pwaText": {
        "header": "Nainstalujte tuto aplikaci na domovskou obrazovku!",
        "button": "Nainstalovat aplikaci",
        "iphoneHeader": "Pro instalaci této aplikace na iPhone",
        "inst1": "Klepněte na tlačítko <b>Sdílet</b> v Safari.",
        "inst2": "Posuňte dolů a vyberte <b>\"Přidat na domovskou obrazovku\".</b>",
        "inst3": "Klepněte na <b>Přidat</b> v pravém horním rohu."
    },
    "filterPage": {
        "filterMenu": {
            "backBtn": "Zpět na předchozí stránku",
            "disclaimer": "Některé výsledky nemusí být zcela relevantní. Prosíme, pečlivě je zkontrolujte.",
            "loading": "Načítání",
            "app": "Aplikace",
            "gitlab": "Gitlab",
            "apps": "Aplikace",
            "all": "Vše",
            "m365": "Moje soubory",
            "jql": "jql",
            "people": "Lidé",
            "emails": "Moje e-maily",
            "teams": "Týmy",
            "community": "Komunita",
            "pages": "Stránky",
            "users": "Uživatelé",
            "noData": "Nenašli jsme žádné výsledky pro",
            "noMoreData": "Žádné další výsledky nebyly nalezeny pro váš dotaz!",
            "filterHeading": "Filtry",
            "reset": "Resetovat filtry",
            "refineResults": "Upřesnit výsledky",
            "card_languages": "Jazyky",
            "ecl_source_name": "Zdroj",
            "standard_card_type": "Typ",
            "mimeType": "Typ",
            "datasources": "Datové zdroje",
            "lookingFor": "Hledám",
            "timeRange": "Časový rozsah",
            "department": "Oddělení",
            "mygenius": "My Genius",
            "jira": "Jira",
            "confluence": "Confluence",
            "orderit": "Moje IT objednávka",
            "aiAssistant": "Asistent",
            "space": "Prostor",
            "time": "Čas",
            "priority": "Priorita",
            "status": "Stav",
            "compass": "Kompas",
            "contentType": "Kategorie",
            "kb_articles": "IT podpora",
            "officeBuddy": "E.ON znalostní báze",
            "key": "Projekt",
            "enterSearchTerm": "Zadejte své hledané slovo a upřesněte výsledky.",
            "categoryTags": "Kategorie",
            "companyTags": "Obchodní oblast",
            "searchIn": "Vyhledávání v"
        },
        "searchResult": {
            "source": "Zdroj",
            "business": "Obchod",
            "mobile": "Mobil",
            "type": "Typ",
            "duration": "Doba trvání",
            "category": "Kategorie",
            "deliveryTime": "Čas doručení",
            "availableLanguages": "Dostupné jazyky",
            "status": "Stav",
            "lastUpdate": "Poslední aktualizace",
            "lastUpdated": "Poslední aktualizace",
            "createdOn": "Vytvořeno dne",
            "createdBy": "Vytvořil",
            "company": "Společnost",
            "department": "Oddělení",
            "job_title": "Název pozice",
            "office_location": "Umístění kanceláře",
            "email": "E-mail",
            "preview": "Náhled",
            "viewEmail": "Zobrazit e-mail"
        },
        "timeRangeOptions": {
            "All": "Vše",
            "yesterday": "1 den",
            "lastWeek": "7 dní",
            "lastMonth": "1 měsíc",
            "6 Months": "6 měsíců",
            "lastYear": "1 rok"
        },
        "dataSources": {
            "Confluence": "Confluence",
            "Gitlab": "Gitlab",
            "JIRA": "Jira",
            "MyGenius": "MyGenius",
            "ItOrder": "moje IT objednávka",
            "Sharepoint": "SharePoint",
            "Knowledge Base": "Znalostní báze",
            "powerpoint": "PowerPoint",
            "word": "Word",
            "excel": "Excel",
            "pdf": "PDF",
            "loop": "Loop",
            "other": "Ostatní"
        },
        "searchOptions": {
            "local": "<BU>",
            "compassWide": "Všechny obchodní oblasti"
        },
        "searchOptionsHover": "Zobrazuje obsah z vaší obchodní oblasti, obsah skupiny E.ON nebo obsah z jiných obchodních oblastí."
    },
    "chatBot": {
        "chatIcon": "ChatBot",
        "sourceName": "Zdroj",
        "searchBack": "Zpět na předchozí stránku",
        "welcomeMessage": "Chat Prompt",
        "chatbotPlaceholder": "Pište sem...",
        "sendbtn": "Odeslat",
        "cancelBtn": "Zrušit",
        "showMore": "Zobrazit více",
        "showMoreTooltip": "Zobrazit úplnou odpověď",
        "showLess": "Zobrazit méně",
        "showLessTooltip": "Minimalizovat úplnou odpověď",
        "continueAssistance": "Pokračovat na Assistance",
        "continueAssistanceTooltip": "Pokračovat na Assistance pro další otázky",
        "feedbackTitle": "Bylo to užitečné?",
        "feedbackThumbsUpLabel": "Ano, pomohlo to",
        "feedbackThumbsDownLabel": "Stále potřebuji pomoc?",
        "feedbackPrompt": "Podělte se o svůj Feedback zde",
        "askMe": "Položte své dotazy",
        "imageUpload": "Nahrát obrázek",
        "uploadImageTooltip": "Nahrajte obrázek a položte otázku.",
        "uploadImageFormat": "Podporovaný formát: JPG/PNG",
        "uploadImageProcessing": "Zpracovávám obrázek...",
        "uploadImageQuestions": "Navrhované otázky:",
        "card": {
            "selfService": "Samoobsluha",
            "efficiency": "Efektivita",
            "ngService": "Next-Gen Service"
        },
        "disclaimerText": "Assistance může generovat obsah, který je nepřesný a chybný. Zkontrolujte důležité informace.",
        "selfServiceTitle": "IT Podpora",
        "selfServiceContent": "Podpora samoobsluhy s AI pro rychlé řešení incidentů",
        "knowledgeBaseTitle": "Znalostní báze",
        "knowledgeBaseContent": "Zlepšování zkušeností zaměstnanců prostřednictvím informací",
        "internetSearchTitle": "Obecné otázky",
        "wentWell": "Co šlo dobře? (volitelné)",
        "wentWrong": "Co nešlo dobře?",
        "privacyMsg": "Respektujeme soukromí a ujišťujeme, že Feedback bude zpracován důvěrně.",
        "appreciateService": "Oceňujeme vaši pomoc při zlepšování našich služeb.",
        "feedbackMessage": "Děkujeme za váš Feedback!",
        "relevantSearches": "Nejrelevantnější vyhledávání",
        "aiAssitanceSuggestion": "Můžete položit své otázky AI Assistance pomocí vstupního pole níže",
        "aiActionMsg": "Zdá se, že vaše interní úložiště je plné. Mohu vám pomoci vyřešit problém s instalací automatickým vyčištěním vašich dočasných souborů a vyprázdněním koše. Chcete, abych automaticky vyčistil?",
        "aiActionPrimaryBtn": "Automaticky vyčistit",
        "aiActionSecondaryBtn": "Nečistit automaticky",
        "aiActionSuccess": "Vaše úložiště bylo vyčištěno.",
        "aiActionFailed": "Něco se pokazilo. Zkuste to prosím později. Nebo to zkuste ručně.",
        "hey": "Ahoj",
        "topicStartMessage": "s jakým IT problémem vám dnes mohu pomoci?",
        "newChat": "Nový chat",
        "open": "Otevřít",
        "close": "Zavřít",
        "recentChats": "Nedávné chaty",
        "ask": "Položit otázku",
        "internet": "Internet",
        "askEon": "Položit otázku E.ON",
        "askInternet": "Položit otázku Internetu",
        "askFollowUpQuestion": "Položit následnou otázku",
        "resolveIssue": "Odeslání Feedback umožní podpůrné akce",
        "resolveIssueAfterFeedback": "Je mi líto, že jsem nemohl vyřešit váš problém. Jak bych vám mohl dále pomoci?",
        "differentiator": "nebo",
        "incident": "Založit tiket služby",
        "creatingIncident": "Vytváření incidentu",
        "liveAgent": "Chat s agentem",
        "requestCallbackBtn": "Požádat o zpětné volání",
        "ticketDescription": "Popis tiketu na základě nedávné diskuse",
        "createIncident": "Vytvořit incident",
        "confirmCreateIncident": "Potvrdit a vytvořit incident",
        "editCreateIncident": "Upravit a vytvořit incident",
        "ticketSuccessMsg": "Váš incident byl úspěšně vytvořen, číslo tiketu: ",
        "ticketErrorMsg": "Něco se pokazilo. Zkuste to prosím později.",
        "chatBotTitle": "Použijte MyHelp Assistance k položení otázky, získání podpory a užitečných informací z interních a externích zdrojů.",
        "duplicateError": "Duplicitní otázka, prosím položte jinou otázku",
        "content": "Obsah",
        "tone": "Tón",
        "information": "Informace",
        "complete": "Kompletní",
        "other": "Jiné",
        "irelevantContent": "Nerelevantní obsah",
        "lackOfDetail": "Nedostatek detailů",
        "incorrectInformation": "Nesprávné informace",
        "copyLink": "Kopírovat odkaz",
        "openLink": "Otevřít odkaz",
        "internetSearchContent": "Na základě ask me anything EON gpt",
        "assignmentGroupForTicket": "eon-uk-gsd",
        "copy": "Kopírovat",
        "share": "Sdílet",
        "copiedMsg": "Úspěšně zkopírováno",
        "copyLinkMsg": "Kopírovat odkaz",
        "sharableLink": "Sdílitelný odkaz",
        "uploadImage": "Nahrajte obrázek a položte otázku",
        "liveAgentChat": {
            "connectWithLiveAgent": "Spojit se s my IT support",
            "connectingWithLiveAgent": "Spojování se s my IT support",
            "connectingHint": "Můžete se vrátit k Assistance kliknutím na odkaz pod chatovacím polem",
            "agentLeftMsg": "Děkujeme za kontaktování E.ON",
            "switchToAssistance": "Ukončit chat a přejít na Assistance",
            "typeMessageHint": "Napište svou zprávu sem...",
            "disconnectingMsg": "Ukončení chatu a přechod na Assistance",
            "continue": "Pokračovat",
            "exitChat": "Ukončit chat",
            "chatSessionEndPrompt": "Chatová relace automaticky skončí za <timer>"
        },
        "requestCallback": {
            "languageConfirmation": "MyHelp Assistance zjistila, že váš výchozí jazyk je „<language>“. Potvrďte připojení k agentovi nebo upravte požadovaný jazyk a typ agenta níže.",
            "channelsText": "Získat zpětné volání přes",
            "languageText": "Komunikační jazyk",
            "channelLabel": "Vyberte kanál",
            "phoneLabel": "Spojit mě přes",
            "languageLabel": "Vyberte jazyk",
            "tryAgain": "Zkusit znovu",
            "technicalIssue": "Nelze dokončit vaše zpětné volání kvůli technickému problému. Zkuste to prosím znovu.",
            "newNumber": "Nové číslo",
            "availableMobileNumbers": "Dostupná mobilní čísla",
            "chosenNumber": "Spojit mě na toto číslo",
            "phoneError": "Prosím, zadejte platné kontaktní číslo",
            "referenceNumber": "Referenční číslo",
            "tooltip": {
                "confirmBtn": "Potvrdit zadání žádosti o zpětné volání",
                "resetBtn": "Resetovat formulář pro vymazání všech výběrů a začít znovu",
                "cancelBtn": "Zrušit zpětné volání"
            },
            "addNewNumber": "nové číslo"
        },
        "quickActions": {
            "heading": "my IT support",
            "actions": {
                "createIncident": "Vytvořit tiket",
                "chatWithServiceDesk": "Zahájit živý chat",
                "requestCallback": "Požádat o zpětné zavolání",
                "ongoingConversation": "Ano, je to součást mé poslední konverzace.",
                "newConversation": "Ne. Potřebuji pomoc při řešení nového problému",
                "confirmAndCreateTicket": "Potvrdit a vytvořit tiket",
                "cancelTicketCreation": "Zrušit vytvoření tiketu",
                "confirmChatWithServiceDesk": "Potvrdit a spojit se s my IT support",
                "cancelChatWithServiceDesk": "Zrušit chat s my IT support",
                "cancelRequestCallback": "Zrušit požadavek na zpětné volání",
                "confirmRequestCallback": "Potvrzení připojení přes <channel> <phone> s agentem my IT support v jazyce <language>"
            },
            "state": {
                "whatsTheIssue": "Jaký problém chcete vyřešit?",
                "lastConversation": "Jistě, je problém součástí poslední konverzace?",
                "createIncidentLabel": "Chystáte se založit tiket incidentu pro",
                "cancelAck": "Zaznamenáno. Mohu vám pomoci s jiným problémem?",
                "chatWithServiceDeskLabel": "Chystáte se spojit s agentem my IT support",
                "createTicketLabel": "Potvrdit a vytvořit tiket",
                "cancelTicketLabel": "Zrušit vytvoření tiketu",
                "creatingIncidentTicket": "Vytváření tiketu incidentu",
                "ticketAttachment": "Prosím, přidejte snímek chyby nebo problému.",
                "ticketAttachmentTooltipInstruction": "Stiskněte klávesu Windows logo + Print screen nebo použijte nástroj pro výstřižky k zachycení snímku.",
                "ticketAttachmentTooltipWarning": "Velikost obrázku musí být menší než 5 MB",
                "ticketAttachmentLabel": "Připojit snímek obrazovky",
                "ticketAttachmentTitle": "Připojený snímek obrazovky pro tiket",
                "ticketAttachmentError": "Nelze připojit vybraný soubor. Ujistěte se, že vybraný soubor je ve formátu jpg, png a menší než 5 MB.",
                "ticketAttachmentErrorAction": "Zkusit znovu",
                "ticketDescription": "Popis tiketu",
                "ticketNonITWarning": "Assistance nenašla klíčová slova k identifikaci vašeho problému jako IT-problému.",
                "ticketNonITWarningQuestion": "Chcete založit incident s my IT support na základě vaší konverzace o",
                "ticketNonITWarningRecommendationLabel": "Doporučení:",
                "ticketNonITWarningRecommendationText": "pokud máte problém, který nesouvisí se softwarem nebo hardwarem, můžete zkusit přeformulovat svůj dotaz nebo položit následnou otázku níže",
                "connectWithServiceDeskLabel": "Potvrdit chat s my IT support",
                "requestCallbackLabel": "Požádat o zpětné volání",
                "requestCallbackInQueuePhone": "Vaše žádost o zpětné volání byla odeslána. Budete kontaktováni přibližně za 5 minut na čísle <strong><phone></strong>. Během čekání můžete nadále používat jiné aplikace.",
                "requestCallbackInQueueTeams": "Vaše žádost o zpětné volání byla odeslána. Budete kontaktováni přibližně za 5 minut prostřednictvím <strong>Microsoft Teams</strong>. Během čekání můžete nadále používat jiné aplikace.",
                "requestCallbackFailed": "Nepodařilo se dokončit vaše zpětné volání kvůli technickému problému. Zkuste to prosím znovu.",
                "requestCallbackPromptAnswer": "Chystáte se požádat o zpětné volání z my IT support",
                "requestCallbackConfirmLabel": "Potvrdit požadavek na zpětné volání"
            },
            "tooltips": {
                "createIncident": "Pomáhá vám při řešení IT problému a vytváření incidentu s my IT support, pokud je to potřeba",
                "chatWithServiceDesk": "Pomáhá vám při řešení IT problému a kontaktování my IT support prostřednictvím chatu, pokud je to potřeba",
                "requestCallback": "Požádat o zpětné volání od my IT support"
            }
        },
        "askTooltip": {
            "eon": "Získat informace specifické pro společnost z interních zdrojů",
            "internet": "Získat informace z interních a externích zdrojů, jako je E.ON GPT"
        },
        "jiraIntegration": {
            "viewInJira": "Zobrazit v Jira",
            "responseHeading": "Zde je shrnutí vašich tiketů Jira:",
            "responseSubheading": "Zobrazuji top 15 záznamů",
            "noResponse": "Zdá se, že pro váš požadavek nejsou momentálně k dispozici žádné tikety JIRA.",
            "supportedQuestionMsg": "Ahoj, omlouvám se. Nerozuměl jsem vaší otázce. Můžete ji prosím přeformulovat? Sdílím několik vzorových otázek, které vám pomohou:"
        },
        "intune": {
            "selectDevice": "Vyberte zařízení",
            "changeBrowserHomePage": "Změnit domovskou stránku prohlížeče",
            "fixWillBeApplied": "Oprava bude použita na tomto systému",
            "confirm": "Potvrdit",
            "fixThis": "Opravit",
            "enterDeviceName": "Zadejte název zařízení",
            "selectOrEnterDevice": "Prosím vyberte zařízení nebo zadejte název svého zařízení.",
            "actionFailed": "Akce selhala.",
            "working": "Probíhá...",
            "fixOnThis": "Použít na tomto zařízení",
            "deviceLabel": "Zařízení",
            "lastActive": "Naposledy aktivní",
            "today": "Dnes",
            "yesterday": "Včera",
            "daysAgo": "dny zpět",
            "deviceTypeLaptop": "Notebook",
            "deviceTypeDesktop": "Stolní počítač",
            "deviceTypeVirtualMachine": "Virtuální stroj",
            "deviceTypeUnknown": "Zařízení",
            "homepageBrowserChange": {
                "syncInstructions": "Změna bude nyní použita na vašem zařízení. Může to trvat přibližně 30 minut. Pokud chcete proces urychlit, můžete spustit ruční synchronizaci z aplikace Company Portal:\n1. Otevřete Company Portal\n2. V levém dolním rohu klikněte na Settings vedle symbolu ozubeného kola.\n3. Poté klikněte na modré tlačítko \"Synchronize\" a počkejte na dokončení synchronizace.",
                "changeHomepageInstructions": "1. Klikněte na tři tečky (...) v pravém horním rohu.\n2. Vyberte „Nastavení“.\n3. V levém menu vyberte „Start, domovská stránka a nové karty“.\n4. V části „Při spuštění“ se ujistěte, že je vybrána/zaškrtnuta možnost „Otevřít vlastní weby“.\n5. Poté klikněte na „Přidat web“.\n6. Zadejte adresu webu, kterou chcete nastavit jako novou domovskou stránku v Microsoft Edge (například: https://compass.eon.com/).\n7. Klikněte na „Přidat“.\n\nPokud chcete web ze seznamu Domovská stránka odebrat, klikněte na tři tečky (...) vedle webu a poté na „Odebrat“.",
                "policyDescription": "Vaše organizace v současné době spravuje nastavení domovské stránky prohlížeče pomocí zásad zařízení. Chcete-li povolit úpravu domovské stránky, musíme nejprve zjistit, které zařízení by mělo obdržet aktualizaci zásad.",
                "deviceSelectedForPolicy": "vybráno pro odemknutí zásad domovské stránky",
                "stepsForEdge": "Kroky pro změnu domovské stránky v Microsoft Edge",
                "whatsNextTitle": "Co bude následovat?",
                "whatsNextSubmitted": "Žádost o povolení přizpůsobitelné domovské stránky byla odeslána do fronty zásad vašeho zařízení.",
                "whatsNextSyncTime": "<strong>30 minut</strong> průměrná doba synchronizace potřebná pro obnovení zásad na pozadí.",
                "whatsNextReturn": "Po 30 minutách se prosím vraťte do nastavení prohlížeče a proveďte níže uvedené kroky.",
                "homepageEnabled": "Nyní můžete změnit nastavení domovské stránky prohlížeče. Vezměte prosím na vědomí, že změna nemusí okamžitě vstoupit v platnost. Počkejte přibližně 30 minut, než se synchronizace dokončí, poté zavřete a znovu otevřete Edge.",
                "homepageAlreadyEnabled": "Vaše zařízení již má povolenou změnu domovské stránky. Přejděte do nastavení prohlížeče a zkuste to znovu.",
                "homepageEnableFailed": "Aktualizace domovské stránky momentálně není možná. Zkuste to prosím později.",
                "homepageRemoved": "Zařízení bylo odebráno ze skupiny zásad domovské stránky."
            }
        },
        "nexthinkIntegration": {
            "failureMsg": "Ups! Něco se pokazilo. Zkuste to prosím později. Pokud problém přetrvává, prosím založte problém z Rychlých akcí",
            "assistanceTask": "Úkol Assistance",
            "myActions": "Mé akce",
            "itReportTitle": "Zde je snímek energetické účinnosti vašich systémů",
            "days": "Dny",
            "device": "Zařízení",
            "sinceRestarted": "od restartování",
            "deviceRestartRecommendation": "Doporučuje se okamžitý restart zařízení",
            "deviceInCompliance": "Vaše zařízení je v souladu",
            "energyConsumed": "Spotřeba energie za posledních 7 dní",
            "coEmitted": "Emise CO2 za posledních 7 dní",
            "cacheActionMsg": "Prosím, znovu spusťte svůj prohlížeč, aby se změny projevily.",
            "diskClean": {
                "primaryBtn": "Ano, vyčistit můj disk nyní",
                "secondaryBtn": "Nečistit nyní",
                "successMsg": "Váš disk byl vyčištěn",
                "successMsgOnList": "Váš disk byl vyčištěn",
                "failureMsg": "Váš disk nemohl být nyní vyčištěn",
                "progressMsg": "Probíhá vyčištění úložiště",
                "disclaimer": "Upozorňujeme, že se nedotkneme vašich osobních nebo pracovních dat. Zatímco probíhá vyčištění na pozadí, neváhejte použít Assistance.",
                "acknowledgeQuery": "Mohu pro vás provést vyčištění disku. Při čištění disku se z vašeho systému odstraní zbytečné soubory, mezipaměti a staré protokoly. Pokračujte kliknutím na tlačítko níže."
            },
            "chromeCache": {
                "primaryBtn": "Ano, vyčistit cache Chrome nyní",
                "secondaryBtn": "Nečistit cache Chrome nyní",
                "successMsg": "Vaše cache Chrome byla vyčištěna. Prosím, znovu spusťte svůj prohlížeč, aby se změny projevily.",
                "successMsgOnList": "Vaše cache Chrome byla vyčištěna",
                "failureMsg": "Vaše cache Chrome nemohla být nyní vyčištěna",
                "progressMsg": "Probíhá vyčištění cache Chrome",
                "disclaimer": "Upozorňujeme, že se nedotkneme vašich osobních nebo pracovních dat. Zatímco probíhá vyčištění na pozadí, neváhejte použít Assistance.",
                "acknowledgeQuery": "Mohu vám pomoci vymazat mezipaměť prohlížeče. Pokračujte kliknutím na tlačítko níže."
            },
            "edgeCache": {
                "primaryBtn": "Ano, vyčistit cache Edge nyní",
                "secondaryBtn": "Nečistit cache Edge nyní",
                "successMsg": "Vaše cache Edge byla vyčištěna. Prosím, znovu spusťte svůj prohlížeč, aby se změny projevily.",
                "successMsgOnList": "Vaše cache Edge byla vyčištěna",
                "failureMsg": "Vaše cache Edge nemohla být nyní vyčištěna",
                "progressMsg": "Probíhá vyčištění cache Edge",
                "disclaimer": "Upozorňujeme, že se nedotkneme vašich osobních nebo pracovních dat. Zatímco probíhá vyčištění na pozadí, neváhejte použít Assistance.",
                "acknowledgeQuery": "Mohu vám pomoci vymazat mezipaměť prohlížeče. Pokračujte kliknutím na tlačítko níže."
            },
            "empowerApp": {
                "primaryBtn": "Ano, prosím opravte nyní",
                "secondaryBtn": "Neopravovat nyní",
                "successMsg": "Automatická oprava úspěšně dokončena",
                "successMsgOnList": "Automatická oprava úspěšně dokončena",
                "failureMsg": "Váš Empower Plugin nemohl být nyní opraven",
                "progressMsg": "Automatická oprava probíhá",
                "disclaimer": "Budeme znovu instalovat Empower plugin, prosím zavřete všechny vaše O365 aplikace před pokračováním.",
                "acknowledgeQuery": "Mohu vám pomoci s problémy souvisejícími s doplňkem Empower. Klikněte níže pro opravu doplňku Empower."
            },
            "teamsCache": {
                "primaryBtn": "Ano, vyčistit cache Teams nyní",
                "secondaryBtn": "Nečistit cache Teams nyní",
                "successMsg": "Vaše cache Teams byla vyčištěna. Můžete otevřít Teams a znovu nakonfigurovat jakékoliv nastavení, které mohlo být resetováno.",
                "successMsgOnList": "Vaše cache Teams byla vyčištěna",
                "failureMsg": "Vaše cache Teams nemohla být nyní vyčištěna",
                "progressMsg": "Probíhá vyčištění cache Teams",
                "disclaimer": "Upozorňujeme, že se nedotkneme vašich osobních nebo pracovních dat. Zatímco probíhá vyčištění na pozadí, neváhejte použít Assistance.",
                "acknowledgeQuery": "Mohu vám pomoci vymazat mezipaměť aplikace Teams. Pokračujte kliknutím na tlačítko níže."
            },
            "teamsReinstall": {
                "primaryBtn": "Ano, přeinstalovat Teams",
                "secondaryBtn": "Nepřeinstalovat Teams",
                "successMsg": "Přeinstalace aplikace Teams je dokončena",
                "successMsgOnList": "Přeinstalace aplikace Teams je dokončena",
                "failureMsg": "Přeinstalace Teams nemohla být dokončena",
                "progressMsg": "Probíhá přeinstalace Teams",
                "disclaimer": "Upozorňujeme, že to současně stáhne a přeinstaluje aplikaci Teams. To restartuje aplikaci Teams, prosím uložte svou práci před pokračováním.",
                "acknowledgeQuery": "Přeinstalování aplikace Microsoft Teams může problém vyřešit. Pokračujte kliknutím na tlačítko níže."
            },
            "outlookOst": {
                "primaryBtn": "Ano, opravit Outlook",
                "secondaryBtn": "Neopravovat Outlook",
                "successMsg": "Profil Outlook byl znovu vytvořen",
                "successMsgOnList": "Profil Outlook byl znovu vytvořen",
                "failureMsg": "Profil Outlook nemohl být znovu vytvořen",
                "progressMsg": "Probíhá znovuvytvoření profilu Outlook",
                "disclaimer": "Provedení této akce znovu vytvoří váš profil Outlook lokálně, to zahájí stahování e-mailů z kancelářské Exchange, prosím zajistěte dostatečnou šířku pásma sítě a úložiště.",
                "acknowledgeQuery": "To může být způsobeno problémy s připojením nebo zastaralým nastavením. Mohu vám pomoci s diagnostikou a obnovit synchronizaci Outlooku."
            },
            "repairOfficeApps": {
                "primaryBtn": "Ano, opravit Office aplikace",
                "secondaryBtn": "Neopravovat Office aplikace",
                "successMsg": "Office aplikace byly opraveny",
                "successMsgOnList": "Office aplikace byly opraveny",
                "failureMsg": "Office aplikace nemohly být opraveny",
                "progressMsg": "Office aplikace jsou přeinstalovány",
                "disclaimer": "Provedení této akce současně přeinstaluje Office aplikace a pokusí se je opravit, prosím uložte veškerou neuloženou práci před pokračováním.",
                "acknowledgeQuery": "Může to být způsobeno poškozenou instalací nebo problémem s kompatibilitou. Mohu vám pomoci opravit aplikace Office, aby se vaše aplikace spouštěly hladce."
            },
            "intuneSync": {
                "primaryBtn": "Ano, zahájit synchronizaci Intune",
                "secondaryBtn": "Nezahajovat synchronizaci",
                "successMsg": "Synchronizace Intune byla dokončena",
                "successMsgOnList": "Synchronizace Intune byla dokončena",
                "failureMsg": "Synchronizace Intune nemohla být zahájena",
                "progressMsg": "Probíhá synchronizace Intune",
                "disclaimer": "Upozorňujeme, že tato akce pouze restartuje služby synchronizace Intune, neprovádí přeinstalaci ani opravu Intune (Company portal).",
                "acknowledgeQuery": "Mohu vám pomoci obnovit stav vašeho zařízení a synchronizovat jej s Intune, aby bylo v souladu, aktualizované a aby se uplatňovaly nejnovější zásady."
            },
            "teamsAddin": {
                "primaryBtn": "Ano, povolit doplněk MS Teams",
                "secondaryBtn": "Nepovolit doplněk",
                "successMsg": "Oprava doplňku MS Teams je dokončena",
                "successMsgOnList": "Oprava doplňku MS Teams je dokončena",
                "failureMsg": "Doplněk MS Teams nemohl být povolen",
                "progressMsg": "Doplněk MS Teams je povolován",
                "disclaimer": "Upozorňujeme, že oprava doplňku MS Teams vyžaduje restartování Outlooku. Prosím uložte veškerou svou práci před pokračováním.",
                "acknowledgeQuery": "Mohu pomoci obnovit doplněk Teams v Outlooku, abyste opět mohli plánovat schůzky. Pokračujte kliknutím na tlačítko níže."
            },
            "windowsUpdate": {
                "primaryBtn": "Ano, zkontrolovat aktualizace",
                "secondaryBtn": "Ne, nekontrolovat",
                "successMsg": "Windows Update byl spuštěn",
                "successMsgOnList": "Windows Update byl spuštěn",
                "failureMsg": "Nelze spustit Windows Update",
                "progressMsg": "Probíhá kontrola aktualizací",
                "disclaimer": "Tato akce je navržena k kontrole a stahování aktualizací od Microsoftu, prosím zajistěte, že jste připojeni k vhodné síti, aby bylo možné stáhnout jakékoliv aktualizace.",
                "acknowledgeQuery": "Mohu pomoci s vyřešením problémů s aktualizacemi Windows a souladem na vašem zařízení. Klikněte na tlačítko níže pro pokračování"
            },
            "smartSolution": {
                "systemName": "Název systému",
                "primaryBtn": "Požádat o kontrolu zdravotního stavu",
                "secondaryBtn": "Ne nyní",
                "askToRunHealthCheck": "Chcete, aby Assistance provedla rychlou kontrolu zdraví?",
                "healthCheckApiRunning": "Analýza a provádění kontroly zdraví na",
                "healthCheckApiFail": "Nepodařilo se získat informace o kontrole zdraví, zkuste to prosím znovu",
                "healthCheckApiSuccess": "Analyzoval jsem systém. Následující problémy přetrvávají:",
                "systemCheckMsg": "Probíhá kontrola systému",
                "systemCheckMessages": {
                    "recentlyStarted": "Systém je aktuální a nedávno spuštěný",
                    "appsHealthy": "Všechny instalace aplikací jsou zdravé",
                    "driveSpace": "Dostatek volného místa na systémovém disku",
                    "noCrashes": "Nedávno nebyly zjištěny žádné pády aplikací"
                },
                "healthCheckNoIssue": "Analyzoval jsem systém. <b>Vše se zdá být v pořádku.</b>",
                "recommendedActionHeading": "Doporučené akce",
                "askForElaboration": "Můžete také rozvést konkrétní problém nebo nahrát snímek problému, který máte.",
                "remindForSystemCheck": "Dobře, můžete mi dát vědět, kdykoli budete chtít provést kontrolu systému.",
                "recommendedFixesHeading": "Doporučené opravy",
                "recommendedActionInfo": "Vyberte nebo zrušte výběr navržených oprav, pokud je to potřeba",
                "noRecommendedAction": "Nejsou k dispozici žádné doporučené akce",
                "initiateActionsButton": "Začít opravovat",
                "selectedActionsProgress": "Vybrané akce jsou zpracovávány.",
                "selectedActionsProgressNote": "Neváhejte použít Assistance, zatímco akce je prováděna. Vaše akce byla přidána do seznamu úkolů Assistance a můžete zkontrolovat pokrok, budete informováni, jakmile bude akce dokončena.",
                "selectedActionsCompleted": "Vybrané akce byly úspěšně dokončeny.",
                "selectedActionsFailed": "Vybrané akce selhaly. Zkontrolujte kartu úkolů Assistance pro podrobnosti.",
                "selectedActionsPartiallyCompleted": "Vybrané akce jsou částečně dokončeny. Zkontrolujte kartu úkolů Assistance pro podrobnosti.",
                "myActionDone": "Označit jako hotové",
                "manualActionDisclaimer": "Tento proces zahrnuje jak automatizované, tak manuální kroky. Prosím, dokončete akce, když je to požadováno",
                "manualActionNotification": "Pro dokončení opravy prosím proveďte další krok(y) ručně uvedené pod 'Mé akce'.",
                "deviceSelectionHeading": "Vidím, že používáte více systémů. Pokud chcete provést následující akci na jiném systému, vyberte ze seznamu níže.",
                "deviceSelectionLabel": "Vyberte systém pro akci Nexthink",
                "alerts": {
                    "successTitle": "Úkol dokončen!",
                    "successMessage": "Vybrané akce byly úspěšně dokončeny.",
                    "errorTitle": "Úkol selhal!",
                    "errorMessage": "Při zpracování vaší vybrané akce došlo k chybě.",
                    "partialTitle": "Úkol dokončen částečně",
                    "partialMessage": "Vybrané akce jsou částečně dokončeny. Zkontrolujte kartu úkolů Assistance pro podrobnosti."
                },
                "reportAndAction": {
                    "systemCrashes": {
                        "message": "Na vašem zařízení došlo k <n> výskytům modrých obrazovek v posledních 7 dnech.",
                        "action": "Prosím, kontaktujte GSD pro další pomoc",
                        "actionInfo": "(Žádná akce) prosím, kontaktujte GSD pro další pomoc"
                    },
                    "edgeCrashes": {
                        "message": "Našli jsme důkazy o <n> pádech prohlížeče Edge v posledních 7 dnech. Pokusíme se to napravit spuštěním skriptu na vašem zařízení.",
                        "action": "Vyčistit cache prohlížeče Edge",
                        "actionInfo": "Tímto se vyčistí cache prohlížeče Edge a nebudou upraveny žádné osobní soubory"
                    },
                    "chromeCrashes": {
                        "message": "Našli jsme důkazy o <n> pádech prohlížeče Chrome v posledních 7 dnech. Pokusíme se to napravit spuštěním skriptu na vašem zařízení.",
                        "action": "Vyčistit cache prohlížeče Chrome",
                        "actionInfo": "Tímto se vyčistí cache prohlížeče Chrome, žádné existující soubory nejsou upraveny."
                    },
                    "ZScalarStatus": {
                        "message": "Zjistili jsme, že služba Zscaler měla na vašem zařízení několik problémů. Můžeme se pokusit to napravit spuštěním skriptu na vašem zařízení.",
                        "action": "Restartovat službu Zscaler",
                        "actionInfo": "Tato akce restartuje síťové připojení. Nemá žádný vliv na vaše otevřené programy."
                    },
                    "ZScalarState": {
                        "message": "Zjistili jsme, že služba Zscaler měla na vašem zařízení několik problémů. Můžeme se pokusit to napravit spuštěním skriptu na vašem zařízení.",
                        "action": "Resetovat Zscaler",
                        "actionInfo": "Tato akce restartuje síťové připojení. Nemá žádný vliv na vaše otevřené programy."
                    },
                    "driveFreeSpace": {
                        "message": "Vaše zařízení má pouze <n> GB volného místa. Pro zajištění optimálního výkonu počítače doporučujeme zvýšit množství volného místa dostupného pro Windows, spuštěním skriptu na vašem zařízení.",
                        "action": "Provést vyčištění disku",
                        "actionInfo": "Pouze vaše dočasné soubory a koš vašeho zařízení jsou vyčištěny v akci"
                    },
                    "daysSinceFullBoot": {
                        "message": "Vaše zařízení nebylo plně restartováno za posledních <n> dní. To se liší od běžného postupu vypnutí. Doporučujeme plně restartovat váš počítač (Start | Vypnout | Restartovat)",
                        "action": "Restartovat zařízení při nejbližší příležitosti.",
                        "actionInfo": ""
                    },
                    "teamsCrashes": {
                        "message": "Zjistili jsme důkazy o <n> pádech souvisejících s Microsoft Teams v posledních 7 dnech. Můžeme se pokusit to napravit spuštěním skriptu k vyčištění cache Microsoft Teams.",
                        "action": "Spustit vyčištění cache Teams",
                        "actionInfo": "Tato akce vyčistí cache MS Teams a restartuje ji. Tím se také mohou smazat koncepty / neodeslané zprávy Teams."
                    },
                    "teamsPluginDisabled": {
                        "message": "Zjistili jsme, že váš doplněk Microsoft Teams v rámci Microsoft Outlook. To způsobuje problémy mezi těmito dvěma aplikacemi. Můžeme se pokusit to napravit spuštěním skriptu k přeformátování těchto nastavení.",
                        "action": "Nastavit doplňky Outlook",
                        "actionInfo": "Tato akce povolí doplněk Teams ve vašem Outlooku a restartuje aplikaci."
                    },
                    "outlookOstStatus": {
                        "message": "Váš profil Outlook překročil svou optimální velikost, což je známé, že způsobuje problémy s vaší schránkou. Můžeme se pokusit to napravit skriptem k znovuvytvoření tohoto souboru.",
                        "action": "Opravit soubor OST Outlook",
                        "actionInfo": "Tímto se přejmenuje váš soubor OST Outlook a restartuje aplikaci. Smaže to jakékoliv koncepty e-mailů."
                    },
                    "lastOsUpdate": {
                        "message": "Vidíme, že služba Windows Update nefunguje podle očekávání a váš počítač byl naposledy aktualizován před <n> dny. Doporučujeme plně restartovat váš počítač (Start | Vypnout | Restartovat), což pomáhá resetovat několik nastavení.",
                        "action": "Restartovat zařízení při nejbližší příležitosti",
                        "actionInfo": ""
                    }
                },
                "acknowledgeQuery": "Mohu vám pomoci diagnostikovat problém s vaším zařízením. Pojďme problém zkontrolovat a vyřešit."
            },
            "declineScriptMsg": "Nechci spustit Nexthink skript, pomozte mi s jiným řešením",
            "timezone": {
                "primaryBtn": "Ano, pokračujte dále",
                "secondaryBtn": "Ne, neaktualizovat",
                "successMsg": "Detekce časového pásma byla nastavena na automatickou",
                "successMsgOnList": "Detekce časového pásma byla nastavena na automatickou",
                "failureMsg": "Konfiguraci časového pásma se nepodařilo aktualizovat",
                "progressMsg": "Aktualizace nastavení časového pásma",
                "disclaimer": "Vezměte prosím na vědomí, že tato akce je navržena tak, aby nastavila službu časového pásma na automatickou, což umožní systému Windows aktualizovat hodiny na ploše na základě detekované polohy.",
                "acknowledgeQuery": "Mohu vám pomoci opravit nastavení systémového času a časového pásma. Většinu problémů souvisejících s časem, jako je posun hodin, nesprávné časové značky, neúspěšné ověřovací kódy nebo chybné časy schůzek, způsobuje nesprávně nastavené časové pásmo nebo vypnutá automatická synchronizace. Kliknutím na tlačítko níže automaticky zjistíte a opravíte konfiguraci času a časového pásma ve Windows."
            },
            "chooseBrowser": "Vyberte pro akci vyčištění mezipaměti prohlížeč",
            "outlookAutoComplete": {
                "primaryBtn": "Ano, vymazat mezipaměť Outlooku",
                "secondaryBtn": "Ne, nevymazávat mezipaměť Outlooku",
                "successMsg": "Mezipaměť automatického dokončování Outlooku byla vymazána",
                "successMsgOnList": "Mezipaměť automatického dokončování Outlooku byla vymazána",
                "failureMsg": "Mezipaměť automatického dokončování Outlooku se nepodařilo vymazat",
                "progressMsg": "Probíhá vymazání mezipaměti automatického dokončování Outlooku",
                "disclaimer": "Upozorňujeme, že vymazáním mezipaměti automatického dokončování Outlooku odstraníte uložené návrhy e-mailových adres. Tuto akci nelze vrátit zpět.",
                "acknowledgeQuery": "Mohu vám pomoci opravit mezipaměť automatického dokončování v Outlooku. Kliknutím na tlačítko níže automaticky opravíte automatické dokončování v Outlooku."
            },
            "restartZscalar": {
                "primaryBtn": "Ano, pokračovat",
                "secondaryBtn": "Ne, nerestartovat Zscaler",
                "successMsg": "Zscaler byl restartován",
                "successMsgOnList": "Zscaler byl restartován",
                "failureMsg": "Zscaler se nepodařilo restartovat",
                "progressMsg": "Probíhá restartování služeb Zscaler",
                "disclaimer": "Upozorňujeme, že restartování Zscaleru může na krátkou dobu odpojit váš internet a pracovní aplikace. Obvykle to trvá méně než minutu.",
                "acknowledgeQuery": "Mohu vám pomoci vyřešit problémy se službami Zscaler. Klikněte na tlačítko níže a problém se Zscalerem opravte."
            },
            "onedrive": {
                "primaryBtn": "Ano, opravit OneDrive",
                "secondaryBtn": "Ne, nespouštět opravu OneDrive",
                "successMsg": "Oprava OneDrive byla dokončena",
                "successMsgOnList": "Oprava OneDrive byla dokončena",
                "failureMsg": "Akci opravy OneDrive se nepodařilo úspěšně dokončit",
                "progressMsg": "Probíhá oprava OneDrive",
                "disclaimer": "Upozornění: Oprava OneDrive způsobí synchronizaci místních souborů do cloudu a může potenciálně narušit vlastní synchronizace pro Onedrive",
                "acknowledgeQuery": "Mohu vám pomoci vyřešit problémy s OneDrivem. Klikněte na tlačítko níže a své problémy s OneDrivem opravte."
            },
            "smartcard": {
                "primaryBtn": "Ano, odstranit Smart card",
                "secondaryBtn": "Ne, neodstraňovat Smartcard",
                "successMsg": "Microsoft Smartcard byla odstraněna",
                "successMsgOnList": "Microsoft Smartcard byla odstraněna",
                "failureMsg": "Nelze odstranit Microsoft Smartcard",
                "progressMsg": "Odstraňování Microsoft Smartcard",
                "disclaimer": "Provedení této akce může trvat až 1 minutu.",
                "acknowledgeQuery": "Mohu vám pomoci vyřešit problémy s Microsoft Smart Card Reader. Klikněte na tlačítko níže a opravte problémy se Smart Card."
            },
            "errorFetchingReport": "Omlouvám se, nepodařilo se mi načíst sestavu. Zkuste to prosím později.",
            "automatedFix": "Automatizovaná oprava",
            "automatedFixConsent": "Mohu tento problém vyřešit na vašem zařízení. Chcete, abych spustil(a) automatickou opravu?",
            "primaryButton": "Ano, spustit opravu",
            "teamViewerReset": {
                "primaryBtn": "Ano, pokračovat dále",
                "secondaryBtn": "Ne, neprovádět reset",
                "successMsg": "Služby Teamviewer byly resetovány",
                "successMsgOnList": "Služby Teamviewer byly resetovány",
                "failureMsg": "Nelze resetovat služby Teamviewer",
                "progressMsg": "Služby Teamviewer se právě restartují",
                "disclaimer": "Tato akce resetuje vaše služby teamviewer a restartuje vaši aplikaci teamviewer, před pokračováním se prosím ujistěte, že máte svou práci uloženou",
                "acknowledgeQuery": "Mohu pomoci resetovat Teamviewer. Pokračujte kliknutím na tlačítko níže."
            },
            "zoomUninstall": {
                "primaryBtn": "Ano, odinstalovat Zoom",
                "secondaryBtn": "Ne, neodinstalovat",
                "successMsg": "Zoom byl odinstalován",
                "successMsgOnList": "Zoom byl odinstalován",
                "failureMsg": "Nelze odinstalovat Zoom",
                "progressMsg": "Probíhá odinstalace aplikace Zoom",
                "disclaimer": "Tato akce odinstaluje z vašeho zařízení aplikaci Zoom a zároveň odstraní veškerá její nastavení.",
                "acknowledgeQuery": "Mohu vám pomoci odinstalovat Zoom. Pokračujte kliknutím na tlačítko níže."
            },
            "webexUninstall": {
                "primaryBtn": "Ano, odinstalovat Webex",
                "secondaryBtn": "Ne, neodinstalovat",
                "successMsg": "Webex byl odinstalován",
                "successMsgOnList": "Webex byl odinstalován",
                "failureMsg": "Nelze odinstalovat Webex",
                "progressMsg": "Probíhá odinstalace aplikace Webex",
                "disclaimer": "Tato akce odinstaluje z vašeho zařízení aplikaci Cisco Webex a zároveň odstraní veškerá její nastavení.",
                "acknowledgeQuery": "Mohu vám pomoci odinstalovat Cisco Webex. Pokračujte kliknutím na tlačítko níže."
            },
            "recommendedAction": "Doporučený postup",
            "noKbArticleFound": "K tomuto problému nebyly nalezeny žádné manuální kroky ani články znalostní báze. K dispozici je však doporučený postup, který jej může vyřešit:"
        },
        "sessions": {
            "title": "Nedávné chaty",
            "clearAll": "Smazat všechny chaty",
            "deleteMessage": "Smazat relaci",
            "footer": "Poznámka: Ukládá se posledních 30 dní konverzace. Zjistit více.",
            "noRecentChat": "Žádné nedávné chaty",
            "startNewChat": "Začít nový chat",
            "learnMore": "Zjistit více.",
            "learnMoreTooltip": "Podle retenční politiky MyHelp budou vaše nedávné chaty k dispozici po dobu 30 dní, pokud nesmažete nedávné chaty pomocí tlačítek smazat nebo vymazat vše."
        },
        "search": "E.ON Search",
        "feedbackMsg": "Děkujeme za váš Feedback! Oceňujeme vaši pomoc při zlepšování našich služeb.",
        "contactNumberPlaceholder": "Kontaktní číslo s kódem země",
        "incidentDetailsLabel": "Shrnutí incidentu",
        "contactNumberLabel": "Prosím, zadejte preferované kontaktní číslo",
        "incError": "Zadejte prosím platné údaje o incidentu",
        "contactError": "Zadejte prosím platné telefonní číslo",
        "searchAsk": "Popište svůj problém, např. resetování hesla...",
        "teamsInsights": {
            "specifyDateTime": "Můžete prosím upřesnit datum a čas, kdy k tomu došlo, a také konkrétní schůzku nebo chat, kterých se to týká?",
            "date": "Datum",
            "getMeetings": "Načíst schůzky",
            "cancel": "Zrušit",
            "noMeetings": "Pro vybrané datum nebyly nalezeny žádné schůzky.",
            "meetingInstruction": "Vyberte prosím konkrétní schůzku, kterou ovlivnily problémy s kvalitou.",
            "identifyIssue": "Identifikovat problém",
            "issueDetectionCompleted": "Detekce problému dokončena.",
            "detectingIssues": "Probíhá detekce problémů na schůzce",
            "recommendedActions": "Doporučené kroky:",
            "noInsightsFound": "Pro vybraný hovor nebyly nalezeny žádné poznatky.",
            "meetingList": "Seznam schůzek",
            "fetchingMeetings": "Načítám všechny schůzky Teams pro daný den",
            "windowsOnly": "Poznatky ze schůzek jsou dostupné pouze pro hovory, ke kterým jste se připojili ze zařízení se systémem Windows.",
            "confirmCreateIncident": "Chcete vytvořit incident kvůli problému zjištěnému na schůzce?",
            "getMeetingsCancelMsg": "Požadavek na načtení schůzek byl zrušen.",
            "identifyIssueCancelMsg": "Požadavek na identifikaci problému byl zrušen.",
            "createIncidentCancelMsg": "Požadavek na vytvoření incidentu byl zrušen.",
            "report": {
                "lowWifiRootCause": "Během hovoru byl signál Wi-Fi slabý, což mohlo způsobit problémy s kvalitou hovoru. Pokud jste byli připojeni z domácí/vzdálené sítě, zkontrolujte prosím vzdálenost od routeru.",
                "networkIssueRootCauseManaged": "Zdá se, že jste byli připojeni z kanceláře E.ON a došlo k síťovým problémům ovlivňujícím kvalitu schůzky. Zvažte prosím založení incidentu a uveďte v něm místo, kde jste se nacházeli.",
                "networkIssueRootCauseUnmanaged": "Zdá se, že jste nebyli připojeni z kanceláře E.ON a mohlo dojít k síťovým problémům, které mohly ovlivnit kvalitu schůzky. Zkontrolujte prosím stabilitu místního Wi-Fi nebo internetového připojení. Pokud je to možné, použijte kabelové připojení nebo se přibližte ke svému Wi-Fi routeru pro zlepšení výkonu sítě.",
                "noDataRootCause": "Pro tento parametr nebyly během hovoru dostupné žádné poznatky.",
                "noIssueRootCause": "U tohoto parametru nebyl zjištěn žádný problém.",
                "noIssueRecommendation": "Není vyžadována žádná akce.",
                "failed": "Selhalo",
                "checking": "Kontrola",
                "okay": "V pořádku",
                "na": "N/A",
                "audio": "Audio",
                "video": "Video",
                "deviceCpuUsage": {
                    "displayName": "Využití CPU zařízení",
                    "rootCause": "Během hovoru jsme na vašem zařízení zaznamenali vysoké zatížení CPU. Zkontrolujte prosím, zda během hovoru neběžely na pozadí další procesy nebo aplikace, a snažte se nemít otevřeno příliš mnoho aplikací, aby mohl být výkon zařízení lépe využit pro schůzku.",
                    "recommendation": "Během hovorů zavřete nepotřebné aplikace na pozadí, aby se snížilo zatížení CPU."
                },
                "deviceMemoryUsedPct": {
                    "displayName": "Využití paměti zařízení",
                    "rootCause": "Během hovoru jsme na vašem zařízení zaznamenali vysoké využití paměti. Zkontrolujte prosím, zda během hovoru neběžely na pozadí další procesy nebo aplikace, a snažte se nemít otevřeno příliš mnoho aplikací, aby mohl být výkon zařízení lépe využit pro schůzku.",
                    "recommendation": "Během hovorů zavřete nepotřebné aplikace na pozadí, aby se snížilo využití paměti."
                },
                "wifiSignalQuality": {
                    "displayName": "Kvalita signálu Wi-Fi",
                    "recommendation": "Přesuňte se blíže k routeru nebo se připojte k silnějšímu zdroji signálu Wi-Fi."
                },
                "audioJitter": {
                    "displayName": "Kolísání zvuku (jitter)"
                },
                "audioJBDelay": {
                    "displayName": "Zpoždění zvukového jitter bufferu"
                },
                "audioRecvLossRate": {
                    "displayName": "Míra ztráty příjmu zvuku"
                },
                "audioRtt": {
                    "displayName": "Doba odezvy zvuku (RTT)"
                },
                "videoRtt": {
                    "displayName": "Doba odezvy videa (RTT)"
                },
                "videoRecvLossRate": {
                    "displayName": "Míra ztráty příjmu videa"
                },
                "wifiChannelCenterFrequencyInKilohertz": {
                    "displayName": "Středová frekvence kanálu Wi-Fi (kHz)",
                    "rootCause": "Používáte připojení Wi-Fi 2,4 GHz, které často způsobuje problémy s kvalitou hovoru. Zvažte prosím přepnutí na pásmo Wi-Fi 5 GHz nebo vyšší.",
                    "recommendation": "Pro zlepšení kvality hovoru přepněte na pásmo Wi-Fi 5 GHz (nebo vyšší)."
                },
                "wifiSsidChangeDetected": {
                    "displayName": "Zjištěna změna sítě",
                    "rootCauseManaged": "Zjistili jsme změnu Wi-Fi sítě nebo přístupového bodu během vašeho hovoru v kanceláři E.ON. To mohlo způsobit přerušení hovoru. Pokud jste se se svým zařízením nepohybovali, založte to prosím jako incidentní tiket.",
                    "rootCauseUnmanaged": "Zjistili jsme, že jste nebyli připojeni z místa E.ON. Zkontrolujte prosím, zda je vaše Wi-Fi připojení stabilní, protože problémy se sítí mohou ovlivnit kvalitu schůzky."
                }
            }
        }
    },
    "snow": {
        "welcomeNote": "Níže naleznete přehled vašich otevřených incidentů, vašich požadavků a vašich IT aktiv.",
        "tabName": {
            "incidents": "Incidenty",
            "orders": "Objednávky",
            "itResources": "IT zdroje",
            "incidentsTable": {
                "noData": "Žádná dostupná data",
                "btnText": "Otevřít nový incident",
                "ongoing": "Probíhající",
                "closed": "Uzavřené",
                "headlineText": "Incidenty"
            },
            "orderTable": {
                "number": "Číslo",
                "catItem": "Kategorie položky",
                "approvalSet": "Sada schválení",
                "state": "Stav",
                "dueDate": "Datum splatnosti",
                "createdOn": "Vytvořeno dne",
                "noData": "Žádná dostupná data",
                "btnText": "Objednat IT služby",
                "headlineText": "Objednávky",
                "tooltipText": "Požádejte o a spravujte IT vybavení, software, licence nebo služby"
            },
            "itResourcesTable": {
                "modelCategory": "Kategorie modelu",
                "model": "Model",
                "computerName": "Název počítače",
                "serialNumber": "Sériové číslo",
                "serviceValue1": "Hodnota služby1",
                "serviceValue2": "Hodnota služby2",
                "noData": "Žádná dostupná data",
                "btnText": "Otevřít tiket pro IT zdroje",
                "headlineText": "Moje aktiva"
            }
        }
    },
    "moveTabAndTiles": {
        "tabNames": "Záložka",
        "favourite": "Oblíbené",
        "categorizeTiles": "Personalizovaný dashboard",
        "enterTabName": "Zadejte název záložky",
        "tabNameError": "Zadejte jedinečný název záložky, minimálně 2 až maximálně 20 znaků!",
        "tabInputLabel": "Název záložky",
        "addTabButton": "Přidat záložku",
        "personalizeTab": "Personalizovat záložky",
        "personalizeTiles": "Personalizovat dlaždice",
        "addTab": "Přidat novou záložku",
        "removeTabConfrim": "Opravdu chcete odstranit záložku",
        "with": " s",
        "cardIn": "dlaždicemi?",
        "actionUndone": "Tuto akci nelze vrátit zpět.",
        "categorizeTilesTitle": "Přejmenovat záložky, odstranit záložky a přesunout dlaždice v rámci záložek",
        "addTabTitle": "Přidat novou záložku. Můžete vytvořit maximálně 4 záložky.",
        "organiseTilesTitle": "Přesunout pozici dlaždic"
    },
    "dataTable": {
        "pagingData": "Položky na stránku",
        "itemString": "položky",
        "ofString": "z"
    },
    "tourData": {
        "userActions": {
            "back": "Zpět",
            "close": "Zavřít",
            "last": "Dokončit",
            "next": "Další",
            "step": "Krok",
            "of": "z",
            "open": "Otevřít dialog",
            "skip": "Přeskočit",
            "start_tour": "Spustit prohlídku",
            "tour_info": "Chcete, abychom vám ukázali základní funkce pomocí rychlé prohlídky? Zabere to jen 1-2 minuty..."
        },
        "tile": {
            "step1": "Použijte MyHelp k nalezení vašich typických pracovních aplikací nebo položte jakoukoliv otázku napříč E.ON zdroji, například IT, vaše projekty, školení, firemní politiky a mnoho dalšího.",
            "step2": "Můžete se dozvědět více o MyHelp a jeho funkcích, najít odpovědi na často kladené otázky a naučit se užitečné tipy a triky v uživatelské dokumentaci.",
            "step3": "Preferovaný jazyk můžete kdykoliv změnit zde.",
            "step4": "Odhlásit se můžete kliknutím zde.",
            "step5": "Začněte novou konverzaci, vyvolejte své poslední chaty, abyste mohli pokračovat tam, kde jste přestali, nebo zahajte E.ON vyhledávání stisknutím lupy",
            "step6": "Váš personalizovaný dashboard vám umožňuje organizovat a přistupovat k vašim oblíbeným pracovním aplikacím. Vyhledejte aplikaci a přidejte ji pomocí symbolu plus. Vytvářejte nové záložky a přeskupujte aplikace podle potřeby."
        },
        "tab": {
            "step1": "Novou záložku můžete přidat kliknutím zde.",
            "step2": "Klikněte zde pro organizaci pořadí dlaždic.",
            "step3": "Zde můžete přejmenovat a organizovat záložky."
        },
        "chat": {
            "step1": "Popište svůj IT problém",
            "step1_description": "Získejte krok za krokem pomoc pro běžné IT problémy – založenou na znalostních databázích IT podpory E.ON. V případě potřeby vás MyHelp také nasměruje na vhodný kanál IT podpory.",
            "step2": "Objevte typické IT požadavky",
            "step2_description": "Tyto příklady ukazují časté IT požadavky, se kterými vám MyHelp může pomoci krok za krokem.",
            "step3": "Přistupujte ke svým aplikacím rychleji",
            "step3_description": "Použijte Dashboard k uložení často používaných aplikací a vytvoření svého osobního pracovního prostoru.",
            "step4": "Zahajte nový chat nebo pokračujte v dřívějších konverzacích",
            "step4_description": "Použijte postranní panel k zahájení nové konverzace nebo k rychlému návratu k dřívějším chatům."
        }
    },
    "allApps": {
        "addAppsBtn": "Přidat aplikace",
        "addAppsInfo": "Klikněte na „Přidat aplikace“ a začněte",
        "addAppsTitle": "Vytvoř si svůj osobní pracovní prostor",
        "addAppsDesc": "Přidejte své nejpoužívanější aplikace pro rychlejší přístup k nástrojům, které používáte každý den",
        "customTileButton": "Přidat vlastní kartu",
        "CustomTileHeading": "Vlastní karta",
        "customTileTitleLabel": "Název karty",
        "customTileSubTitle": "Popis karty",
        "customTileUrlLabel": "Odkaz na kartu",
        "createCardBtn": "Vytvořit kartu",
        "modalHeading": "Aplikace na E.ON",
        "modalDesc": "Vyhledejte nebo vyberte aplikaci, kterou chcete přidat na domovskou stránku",
        "titleRequired": "Název karty je povinný",
        "linkRequired": "Odkaz na kartu je povinný",
        "searchPlaceholder": "Vyhledat aplikaci"
    },
    "onboardingPortal": {
        "onboardAppBtn": "Portál pro onboarding",
        "heading": "Portál pro onboarding aplikací",
        "subHeading": "Zkontrolujte svou aplikaci, zaveďte nové a sdílejte přístup ke správě se svým týmem.",
        "modules": {
            "home": "Domů",
            "apps": "Aplikace",
            "appsLabel": "Aplikace",
            "qna": "Q&A",
            "qnaLabel": "Otázka a odpověď",
            "review": "Recenze",
            "reviewLabel": "Recenze",
            "onboardApp": "Zavést novou aplikaci",
            "manageApp": "Spravovat aplikace",
            "defaultApps": "Výchozí aplikace",
            "onboardQnA": "Zavést QnA",
            "manageQnA": "Spravovat QnA",
            "reviewDashboard": "Přehled recenzenta",
            "reviewApps": "Zkontrolovat aplikace",
            "reviewQnA": "Zkontrolovat Q&A"
        },
        "appOnboardingForm": {
            "formHeading": "Zavést novou aplikaci",
            "successAlert": "Aplikace byla úspěšně zavedena!",
            "appTitleLabel": "Název aplikace",
            "appTitleTooltip": "Název aplikace k zobrazení",
            "appTitlePlaceholder": "Název aplikace k zobrazení",
            "appTitleError": "Název aplikace je povinný",
            "appSubTitleLabel": "Podtitul aplikace",
            "appSubTitleTooltip": "Podtitul aplikace",
            "appSubTitlePlaceholder": "Podtitul aplikace",
            "appSubTitleError": "Podtitul aplikace je povinný",
            "appUrlLabel": "URL aplikace",
            "appUrlTooltip": "Cílová URL aplikace",
            "appUrlPlaceholder": "Cílová URL aplikace",
            "appUrlError": "URL aplikace je povinná",
            "appKeywordsLabel": "synKeywords (oddělená čárkami)",
            "appKeywordsTooltip": "Zadejte synonyma, která by uživatelé mohli použít k nalezení aplikace, a oddělte je čárkou",
            "appKeywordsPlaceholder": "Zadejte synonyma, která by uživatelé mohli použít k nalezení aplikace, a oddělte je čárkou",
            "appKeywordsError": "Klíčová slova jsou povinná",
            "appCompaniesAllowedLabel": "Povolené společnosti",
            "appCompaniesAllowedTooltip": "Seznam všech společností, kde je tato aplikace povolena. Pokud je povolena pro všechny, ponechte prázdné.",
            "appCompaniesAllowedInfoMessage": "Seznam všech společností, kde je tato aplikace povolena. Pokud je povolena pro všechny, ponechte prázdné.",
            "appCompaniesAllowedOtherLabel": "Jiné povolené společnosti",
            "appCompaniesAllowedOtherPlaceholder": "Uveďte jiné povolené společnosti",
            "appCompaniesRestrictedLabel": "Omezené společnosti",
            "appCompaniesRestrictedTooltip": "Seznam všech společností, kde tato aplikace NENÍ povolena. Pokud není žádné omezení, ponechte prázdné.",
            "appCompaniesRestrictedInfoMessage": "Seznam všech společností, kde tato aplikace NENÍ povolena. Pokud není žádné omezení, ponechte prázdné.",
            "appCompaniesRestrictedOtherLabel": "Jiné omezené společnosti",
            "appCompaniesRestrictedOtherPlaceholder": "Uveďte jiné omezené společnosti",
            "appTooltipLabel": "Tooltip (uveďte všechny jazyky, pokud se mají zobrazovat různé názvy)",
            "appTooltipTooltip": "Uveďte všechny jazyky, pokud se mají zobrazovat různé názvy, např. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipPlaceholder": "Uveďte všechny jazyky, pokud se mají zobrazovat různé názvy, např. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipError": "Tooltip je povinný",
            "appIconLabel": "Nahrát ikonu aplikace",
            "appIconTooltip": "Nahrát ikonu aplikace",
            "previewAppBtn": "Náhled aplikace",
            "cancelBtn": "Zrušit",
            "closeBtn": "Zavřít",
            "submitAppBtn": "Odeslat aplikaci",
            "updateAppBtn": "Aktualizovat aplikaci",
            "editAppBtn": "Upravit aplikaci",
            "appTitlePreview": "Název",
            "appSubTitlePreview": "Podtitul",
            "appUrlPreview": "URL",
            "appKeywordsPreview": "Klíčová slova",
            "appCompaniesAllowedPreview": "Povolené společnosti",
            "appCompaniesRestrictedPreview": "Omezené společnosti",
            "appTooltipPreview": "Tooltip",
            "message": "Po odeslání aplikace získá stav Čeká na vyřízení a prochází definovaným procesem přezkoumání — postupuje od Čeká na vyřízení → Schváleno (v přezkumu/testování) → V QA (formálně schváleno a ověřováno) → V produkci (živé a viditelné pro koncové uživatele na MyHelp), nebo může být Odmítnuto, pokud nesplňuje kritéria; v takovém případě může zainteresovaná strana aplikaci upravit a znovu odeslat."
        },
        "qnaOnboardingForm": {
            "formHeading": "Zavést nové QnA",
            "successAlert": "QnA bylo úspěšně zavedeno!",
            "qnaQuestionLabel": "Otázka",
            "qnaQuestionTooltip": "Zadejte otázku pro položku QnA",
            "qnaQuestionPlaceholder": "Zadejte otázku",
            "qnaQuestionError": "Otázka je povinná",
            "qnaAnswerLabel": "Odpověď",
            "qnaAnswerTooltip": "Zadejte odpověď pro položku QnA",
            "qnaAnswerPlaceholder": "Zadejte odpověď na otázku",
            "qnaAnswerError": "Odpověď je povinná",
            "qnaCategoryLabel": "Kategorie",
            "qnaCategoryTooltip": "Vyberte kategorii pro položku QnA",
            "qnaCategoryPlaceholder": "Vyberte kategorii pro položku QnA",
            "qnaCategoryError": "Kategorie je povinná",
            "qnaCategoryOtherLabel": "Jiná kategorie",
            "qnaCategoryOtherPlaceholder": "Zadejte vlastní kategorii",
            "qnaCompaniesAllowedLabel": "Povolené společnosti",
            "qnaCompaniesAllowedTooltip": "Seznam všech společností, kde je tato aplikace povolena. Pokud je povolena pro všechny, ponechte prázdné.",
            "qnaCompaniesAllowedInfoMessage": "Seznam všech společností, kde je tato aplikace povolena. Pokud je povolena pro všechny, ponechte prázdné.",
            "qnaCompaniesAllowedOtherLabel": "Jiné povolené společnosti",
            "qnaCompaniesAllowedOtherPlaceholder": "Uveďte jiné povolené společnosti",
            "qnaCompaniesRestrictedLabel": "Omezené společnosti",
            "qnaCompaniesRestrictedTooltip": "Seznam všech společností, kde tato aplikace NENÍ povolena. Pokud není žádné omezení, ponechte prázdné.",
            "qnaCompaniesRestrictedInfoMessage": "Seznam všech společností, kde tato aplikace NENÍ povolena. Pokud není žádné omezení, ponechte prázdné.",
            "qnaCompaniesRestrictedOtherLabel": "Jiné omezené společnosti",
            "qnaCompaniesRestrictedOtherPlaceholder": "Uveďte jiné omezené společnosti",
            "previewQnABtn": "Náhled QnA",
            "cancelBtn": "Zrušit",
            "submitQnABtn": "Odeslat QnA",
            "updateQnABtn": "Aktualizovat QnA",
            "editQnABtn": "Upravit QnA",
            "addNewQnABtn": "+ Přidat QnA",
            "qnaQuestionPreview": "Otázka",
            "qnaAnswerPreview": "Odpověď",
            "qnaCompaniesAllowedPreview": "Povolené společnosti",
            "qnaCompaniesRestrictedPreview": "Omezené společnosti",
            "message": "Po odeslání záznamu Q&A získá stav Čeká na vyřízení a prochází definovaným procesem přezkoumání — postupuje od Čeká na vyřízení → Schváleno (v přezkumu/testování) → V QA (formálně schváleno a ověřováno) → V produkci (živé a viditelné pro koncové uživatele na MyHelp), nebo může být Odmítnuto, pokud nesplňuje kritéria; v takovém případě může zainteresovaná strana záznam upravit a znovu odeslat."
        },
        "manageBtn": "Spravovat",
        "refreshBtn": "Obnovit",
        "exportBtn": "Exportovat",
        "exportCsvBtn": "CSV",
        "exportExcelBtn": "Excel",
        "exportAppsCsvBtn": "Exportovat aplikace jako CSV",
        "exportAppsExcelBtn": "Exportovat aplikace jako Excel",
        "exportQnACsvBtn": "Exportovat QnA jako CSV",
        "exportQnAExcelBtn": "Exportovat QnA jako Excel",
        "approveBtn": "Schválit",
        "rejectBtn": "Odmítnout",
        "toQABtn": "Přesunout do QA",
        "toProdBtn": "Přesunout do produkce",
        "editBtn": "Upravit",
        "viewBtn": "Zobrazit",
        "closeBtn": "Zavřít",
        "dashboard": {
            "appsTitle": "Přístupné aplikace",
            "appsText": "Aplikace dostupné díky vlastnictví nebo sdílení v týmu.",
            "qnaTitle": "Otázky a odpovědi",
            "qnaText": "Otázky a odpovědi dostupné díky vlastnictví nebo sdílení v týmu."
        },
        "modalLabel": {
            "reviewAppTitle": "Zkontrolovat aplikaci pro integraci",
            "reviewQnATitle": "Zkontrolovat Q&A pro integraci",
            "owner": "Vlastník",
            "createdOn": "Vytvořeno",
            "status": "Stav",
            "url": "URL",
            "tooltip": "Tooltip",
            "companiesAllowed": "Povolené společnosti",
            "companiesRestricted": "Zakázané společnosti",
            "keywords": "Klíčová slova",
            "reviewerComments": "Komentáře k recenzi",
            "category": "Kategorie",
            "question": "Otázka",
            "answer": "Odpověď",
            "mail": "E-mail"
        },
        "statusLabel": {
            "pending": "Na vyřízení",
            "approved": "Schváleno",
            "rejected": "Odmítuto",
            "onhold": "Pozastaveno",
            "unknown": "Neznámý",
            "all": "Vše",
            "inQA": "V QA",
            "inProd": "V produkci"
        },
        "activityLabel": {
            "allowed": "Povoleno",
            "restricted": "Omezeno"
        },
        "tableHeaders": {
            "status": "Status",
            "action": "Akce",
            "icon": "Ikona",
            "title": "Název",
            "subTitle": "Podnázev",
            "question": "Otázka",
            "answer": "Odpověď",
            "category": "Kategorie",
            "owner": "Vlastník",
            "description": "Popis",
            "apps": "Aplikace",
            "qna": "Otázka a odpověď",
            "defaultApps": "Výchozí aplikace",
            "defaultAppsActivity": "Změny výchozích aplikací",
            "search": "Hledat",
            "selectCompany": "Vybrat společnost",
            "otherCompany": "Název jiné společnosti",
            "selectAll": "Vybrat vše",
            "company": "Společnost",
            "update": "Aktualizovat",
            "comments": "Komentáře"
        },
        "noData": {
            "dashboardEmpty": "Nebyly přidány žádné aplikace ani Q&A",
            "dashboardAppsEmpty": "Nebyly přidány žádné aplikace",
            "dashboardQnAEmpty": "Nebyly přidány žádné Q&A",
            "reviewDashboardEmpty": "K recenzi nebyly odeslány žádné aplikace ani Q&A.",
            "reviewAppsEmpty": "K recenzi nebyly odeslány žádné aplikace.",
            "reviewQnAEmpty": "K recenzi nebyly odeslány žádné Q&A."
        },
        "manageApp": {
            "heading": "Spravovat aplikace",
            "subHeading": "Zobrazují se pouze aplikace, které vlastníte nebo ke kterým vám byl udělen přístup."
        },
        "manageQnA": {
            "heading": "Spravovat QnA",
            "subHeading": "Zobrazují se pouze QnA, která vlastníte nebo ke kterým vám byl udělen přístup."
        },
        "defaultApps": {
            "heading": "Výchozí aplikace",
            "subHeading": "Toto jsou aplikace, které jsou ve výchozím nastavení dostupné pro všechny uživatele. Zobrazené aplikace můžete změnit aktivací nebo deaktivací.",
            "searchPlaceholder": "Hledat aplikace"
        },
        "reviewDashboard": {
            "heading": "Přehled recenzí",
            "subHeading": "Zkontrolujte čekající požadavky na onboarding aplikací a schvalte je nebo zamítněte. Vaše včasné recenze nám pomáhají udržovat relevantní a užitečnou kolekci aplikací pro všechny."
        },
        "reviewApps": {
            "heading": "Recenze aplikací",
            "subHeading": "Zkontrolujte čekající požadavky na onboarding aplikací a schvalte je nebo zamítněte. Vaše včasné recenze nám pomáhají udržovat relevantní a užitečnou kolekci aplikací pro všechny."
        },
        "reviewQnA": {
            "heading": "Recenze Q&A",
            "subHeading": "Zkontrolujte čekající požadavky na onboarding QnA a schvalte je nebo zamítněte. Vaše včasné recenze nám pomáhají udržovat relevantní a užitečnou kolekci QnA pro všechny."
        },
        "reviewQueue": {
            "heading": "Fronta kontroly",
            "subHeading": "Zkontrolujte a schvalte nebo zamítněte čekající požadavky na zavedení aplikace. Vaše včasné recenze nám pomáhají udržovat relevantní a užitečnou kolekci aplikací pro všechny."
        },
        "activityLog": {
            "heading": "Protokol aktivit"
        },
        "quickActions": {
            "title": "Rychlé akce",
            "onboardNewApp": "Zavést novou aplikaci",
            "manageApps": "Spravovat aplikace",
            "defaultApps": "Výchozí aplikace",
            "onboardNewQnA": "Zavést novou otázku a odpověď",
            "manageQnA": "Spravovat otázky a odpovědi",
            "reviewerDashboard": "Přehled recenzenta",
            "reviewApps": "Zkontrolovat zavedené aplikace",
            "reviewQnA": "Zkontrolovat zavedené Q&A"
        }
    },
    "sourceSelector": {
        "title": "Vybrat zdroj",
        "allSources": "Všechny zdroje",
        "allSourcesDesc": "Vyhledávání ve všech interních informačních zdrojích E.ON",
        "eonKnowledgeBase": "E.ON Databáze znalostí",
        "eonKnowledgeBaseDesc": "Přístup k obecným znalostem společnosti",
        "eonMyItOrder": "E.ON Moje IT objednávky",
        "eonMyItOrderDesc": "Správa a sledování objednávek IT služeb",
        "eonItKnowledgeBase": "E.ON IT Databáze znalostí",
        "eonItKnowledgeBaseDesc": "Vyhledávání IT informací a řešení",
        "myGenius": "My Genius",
        "myGeniusDesc": "Prozkoumejte interní kurzy a materiály",
        "confluenceAll": "Confluence (Vše)",
        "confluenceAllDesc": "Procházení kolaborativní dokumentace",
        "sharepointAll": "SharePoint (Vše)",
        "sharepointAllDesc": "Procházení sdílených souborů a zdrojů",
        "eonApps": "E.ON Aplikace",
        "eonAppsDesc": "Objevování a využívání podnikových aplikací",
        "hrPolicies": "HR Politiky",
        "hrPoliciesDesc": "Přístup k HR politikám a příručkám",
        "compass": "Compass",
        "compassDesc": "Prozkoumejte E.ON Intranet",
        "back": "Zpět",
        "search": "Hledat...",
        "noMatches": "Žádné shody"
    },
    "ailoader": {
        "thinking": "Přemýšlení",
        "reading": "Čtení zdrojů",
        "processing": "Zpracování",
        "analysing": "Analýza výsledků",
        "preparing": "Příprava odpovědi",
        "working": "Pracuji na vaší odpovědi - Může to chvíli trvat."
    },
    "compassScopeSelector": {
        "title": "Vyberte obchodní jednotku",
        "iconLabel": "Rozsah vyhledávání",
        "localSearch": "Lokální vyhledávání",
        "compassWideSearch": "Vyhledávání v celém Compass",
        "resetToCompassWide": "Obnovit vyhledávání v celém Compass",
        "switchToLocal": "Přepnout na lokální vyhledávání",
        "localDescription": "Hledat v rámci vaší společnosti a veřejných příspěvků",
        "compassWideDescription": "Hledat ve všech obchodních jednotkách"
    },
    "errorMessages": {
        "azureAiContentViolation": "Odpověď byla filtrována kvůli dotazu, který aktivoval politiku správy obsahu Azure OpenAI. Prosím upravte svůj dotaz a zkuste to znovu."
    }
}
